/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * rain/v1/thread_service.proto
 * OpenAPI spec version: version not set
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import * as axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import type {
  RpcStatus,
  RunClearThreadMemory200,
  RunClearThreadMemoryParams,
  RunDeleteAllThreads200,
  RunDeleteAllThreadsParams,
  RunDeleteArtifact200,
  RunDeleteArtifactParams,
  RunDeleteThread200,
  RunDeleteThreadParams,
  RunGetActivePlanParams,
  RunGetArtifactContentParams,
  RunGetArtifactDiffParams,
  RunGetArtifactParams,
  RunGetArtifactsStagingSummaryParams,
  RunGetEmbedderInfoParams,
  RunGetEventsParams,
  RunGetFilterSchemaParams,
  RunGetModelInfoParams,
  RunGetQueueParams,
  RunGetThreadContextParams,
  RunGetThreadCostSummaryParams,
  RunGetThreadCustomizationsParams,
  RunGetThreadMemoryBlockParams,
  RunGetThreadMemoryParams,
  RunGetThreadParams,
  RunGetToolParams,
  RunGetUtilityGeneratorModelInfoParams,
  RunListAllThreadsParams,
  RunListArtifactsParams,
  RunListThreadsParams,
  RunSendMessageSync200,
  RunSubscribeAgentThreadStatus200,
  RunSubscribeThread200,
  RunSubscribeThreadStatus200,
  RunTransfer200,
  ThreadServiceActivatePlanBody,
  ThreadServiceCommitArtifactsBody,
  ThreadServiceCreateThreadBody,
  ThreadServiceDeactivatePlanBody,
  ThreadServiceDehydrateThreadBody,
  ThreadServiceDeleteEventBody,
  ThreadServiceDeployBody,
  ThreadServiceDiffArtifactsBody,
  ThreadServiceDiscardArtifactsBody,
  ThreadServiceEmbedAudioBatchBody,
  ThreadServiceEmbedAudioBody,
  ThreadServiceEmbedImageBatchBody,
  ThreadServiceEmbedImageBody,
  ThreadServiceEmbedTextBatchBody,
  ThreadServiceEmbedTextBody,
  ThreadServiceEmbedVideoBatchBody,
  ThreadServiceEmbedVideoBody,
  ThreadServiceForkThreadBody,
  ThreadServiceGrepArtifactsBody,
  ThreadServiceInvokeToolBody,
  ThreadServiceMarkStepBody,
  ThreadServiceRehydrateThreadBody,
  ThreadServiceResetConfigBody,
  ThreadServiceResetEventsBody,
  ThreadServiceResetPlanBody,
  ThreadServiceRestoreEventBody,
  ThreadServiceSendMessageBody,
  ThreadServiceSendMessageSyncBody,
  ThreadServiceSendToolCallBody,
  ThreadServiceSendToolResultBody,
  ThreadServiceSetFeedbackBody,
  ThreadServiceStartCompactionBody,
  ThreadServiceStopBody,
  ThreadServiceTransferBody,
  ThreadServiceUpdateArtifactBody,
  ThreadServiceUpdateThreadBody,
  ThreadServiceUpdateThreadMemoryBody,
  ThreadServiceUpgradeAllThreadsBody,
  ThreadServiceUpgradeThreadBody,
  ThreadServiceWakeBody,
  V1Artifact,
  V1ArtifactContentResponse,
  V1CommitArtifactsResponse,
  V1DeleteEventResponse,
  V1DeployResponse,
  V1DiffArtifactsResponse,
  V1DiscardArtifactsResponse,
  V1EmbedBatchResponse,
  V1EmbedResponse,
  V1EmbedderInfo,
  V1FilterSchemaResponse,
  V1GetArtifactDiffResponse,
  V1GetArtifactsStagingSummaryResponse,
  V1GetEventsResponse,
  V1GetQueueResponse,
  V1GetThreadContextResponse,
  V1GetThreadMemoryResponse,
  V1GrepArtifactsResponse,
  V1InvokeToolResponse,
  V1ListAllThreadsResponse,
  V1ListArtifactsResponse,
  V1ListThreadsResponse,
  V1ListToolsRequest,
  V1ListToolsResponse,
  V1MemoryBlock,
  V1ModelInfo,
  V1Plan,
  V1ResetConfigResponse,
  V1ResetEventsResponse,
  V1RestoreEventResponse,
  V1SendMessageResponse,
  V1SendToolCallResponse,
  V1SendToolResultResponse,
  V1SetFeedbackResponse,
  V1StartCompactionResponse,
  V1StopResponse,
  V1SubscribeAgentThreadStatusRequest,
  V1SubscribeThreadRequest,
  V1SubscribeThreadStatusRequest,
  V1Thread,
  V1ThreadCostSummary,
  V1ThreadCustomizationsResponse,
  V1Tool,
  V1UpgradeAllThreadsResponse,
  V1UpgradeThreadResponse,
  V1WakeResponse,
} from '../../models';

/**
 * @summary Lists all threads for an agent.
 */
export const runListThreads = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  params?: RunListThreadsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListThreadsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRunListThreadsQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  run?: string,
  agentId?: string,
  params?: RunListThreadsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRunListThreadsQueryOptions = <
  TData = Awaited<ReturnType<typeof runListThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  params?: RunListThreadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof runListThreads>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRunListThreadsQueryKey(
      organization,
      workspace,
      automation,
      run,
      agentId,
      params,
    );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof runListThreads>>> = ({
    signal,
  }) =>
    runListThreads(organization, workspace, automation, run, agentId, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation && run && agentId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof runListThreads>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RunListThreadsQueryResult = NonNullable<
  Awaited<ReturnType<typeof runListThreads>>
>;
export type RunListThreadsQueryError = AxiosError<RpcStatus>;

export function useRunListThreads<
  TData = Awaited<ReturnType<typeof runListThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  params: undefined | RunListThreadsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof runListThreads>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof runListThreads>>,
          TError,
          Awaited<ReturnType<typeof runListThreads>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunListThreads<
  TData = Awaited<ReturnType<typeof runListThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  params?: RunListThreadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof runListThreads>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof runListThreads>>,
          TError,
          Awaited<ReturnType<typeof runListThreads>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunListThreads<
  TData = Awaited<ReturnType<typeof runListThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  params?: RunListThreadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof runListThreads>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists all threads for an agent.
 */

export function useRunListThreads<
  TData = Awaited<ReturnType<typeof runListThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  params?: RunListThreadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof runListThreads>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRunListThreadsQueryOptions(
    organization,
    workspace,
    automation,
    run,
    agentId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Deletes all threads for an agent.
 */
export const runDeleteAllThreads = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  params?: RunDeleteAllThreadsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RunDeleteAllThreads200>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRunDeleteAllThreadsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runDeleteAllThreads>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      params?: RunDeleteAllThreadsParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runDeleteAllThreads>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    params?: RunDeleteAllThreadsParams;
  },
  TContext
> => {
  const mutationKey = ['runDeleteAllThreads'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runDeleteAllThreads>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      params?: RunDeleteAllThreadsParams;
    }
  > = props => {
    const { organization, workspace, automation, run, agentId, params } =
      props ?? {};

    return runDeleteAllThreads(
      organization,
      workspace,
      automation,
      run,
      agentId,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunDeleteAllThreadsMutationResult = NonNullable<
  Awaited<ReturnType<typeof runDeleteAllThreads>>
>;

export type RunDeleteAllThreadsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Deletes all threads for an agent.
 */
export const useRunDeleteAllThreads = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runDeleteAllThreads>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        params?: RunDeleteAllThreadsParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runDeleteAllThreads>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    params?: RunDeleteAllThreadsParams;
  },
  TContext
> => {
  const mutationOptions = getRunDeleteAllThreadsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * The thread_id is auto-generated. Optionally provide a title and description.
 * @summary Creates a new thread.
 */
export const runCreateThread = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadServiceCreateThreadBody: ThreadServiceCreateThreadBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Thread>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads`,
    threadServiceCreateThreadBody,
    options,
  );
};

export const getRunCreateThreadMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runCreateThread>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      data: ThreadServiceCreateThreadBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runCreateThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    data: ThreadServiceCreateThreadBody;
  },
  TContext
> => {
  const mutationKey = ['runCreateThread'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runCreateThread>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      data: ThreadServiceCreateThreadBody;
    }
  > = props => {
    const { organization, workspace, automation, run, agentId, data } =
      props ?? {};

    return runCreateThread(
      organization,
      workspace,
      automation,
      run,
      agentId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunCreateThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof runCreateThread>>
>;
export type RunCreateThreadMutationBody = ThreadServiceCreateThreadBody;
export type RunCreateThreadMutationError = AxiosError<RpcStatus>;

/**
 * @summary Creates a new thread.
 */
export const useRunCreateThread = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runCreateThread>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        data: ThreadServiceCreateThreadBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runCreateThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    data: ThreadServiceCreateThreadBody;
  },
  TContext
> => {
  const mutationOptions = getRunCreateThreadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns thread metadata and event count without loading the full event history.
Returns NOT_FOUND if the thread doesn't exist.
 * @summary Gets a thread by ID.
 */
export const runGetThread = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetThreadParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Thread>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRunGetThreadQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  run?: string,
  agentId?: string,
  threadId?: string,
  params?: RunGetThreadParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRunGetThreadQueryOptions = <
  TData = Awaited<ReturnType<typeof runGetThread>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetThreadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof runGetThread>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRunGetThreadQueryKey(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof runGetThread>>> = ({
    signal,
  }) =>
    runGetThread(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(
      organization &&
      workspace &&
      automation &&
      run &&
      agentId &&
      threadId
    ),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof runGetThread>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RunGetThreadQueryResult = NonNullable<
  Awaited<ReturnType<typeof runGetThread>>
>;
export type RunGetThreadQueryError = AxiosError<RpcStatus>;

export function useRunGetThread<
  TData = Awaited<ReturnType<typeof runGetThread>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params: undefined | RunGetThreadParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof runGetThread>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetThread>>,
          TError,
          Awaited<ReturnType<typeof runGetThread>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetThread<
  TData = Awaited<ReturnType<typeof runGetThread>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetThreadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof runGetThread>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetThread>>,
          TError,
          Awaited<ReturnType<typeof runGetThread>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetThread<
  TData = Awaited<ReturnType<typeof runGetThread>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetThreadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof runGetThread>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets a thread by ID.
 */

export function useRunGetThread<
  TData = Awaited<ReturnType<typeof runGetThread>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetThreadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof runGetThread>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRunGetThreadQueryOptions(
    organization,
    workspace,
    automation,
    run,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Deletes a thread and all its events.
 */
export const runDeleteThread = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunDeleteThreadParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RunDeleteThread200>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRunDeleteThreadMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runDeleteThread>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      params?: RunDeleteThreadParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runDeleteThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    params?: RunDeleteThreadParams;
  },
  TContext
> => {
  const mutationKey = ['runDeleteThread'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runDeleteThread>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      params?: RunDeleteThreadParams;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      params,
    } = props ?? {};

    return runDeleteThread(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunDeleteThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof runDeleteThread>>
>;

export type RunDeleteThreadMutationError = AxiosError<RpcStatus>;

/**
 * @summary Deletes a thread and all its events.
 */
export const useRunDeleteThread = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runDeleteThread>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        params?: RunDeleteThreadParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runDeleteThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    params?: RunDeleteThreadParams;
  },
  TContext
> => {
  const mutationOptions = getRunDeleteThreadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Updates a thread's title and/or description.
 */
export const runUpdateThread = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceUpdateThreadBody: ThreadServiceUpdateThreadBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Thread>> => {
  return axios.default.patch(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}`,
    threadServiceUpdateThreadBody,
    options,
  );
};

export const getRunUpdateThreadMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runUpdateThread>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceUpdateThreadBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runUpdateThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceUpdateThreadBody;
  },
  TContext
> => {
  const mutationKey = ['runUpdateThread'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runUpdateThread>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceUpdateThreadBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runUpdateThread(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunUpdateThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof runUpdateThread>>
>;
export type RunUpdateThreadMutationBody = ThreadServiceUpdateThreadBody;
export type RunUpdateThreadMutationError = AxiosError<RpcStatus>;

/**
 * @summary Updates a thread's title and/or description.
 */
export const useRunUpdateThread = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runUpdateThread>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceUpdateThreadBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runUpdateThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceUpdateThreadBody;
  },
  TContext
> => {
  const mutationOptions = getRunUpdateThreadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * This promotes the thread's per-thread config to become the new agent defaults.
The thread's customization remains in place.
 * @summary Deploys the thread's config customizations to the agent template.
 */
export const runDeploy = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceDeployBody: ThreadServiceDeployBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1DeployResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/agent:deploy`,
    threadServiceDeployBody,
    options,
  );
};

export const getRunDeployMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runDeploy>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDeployBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runDeploy>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDeployBody;
  },
  TContext
> => {
  const mutationKey = ['runDeploy'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runDeploy>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDeployBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runDeploy(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunDeployMutationResult = NonNullable<
  Awaited<ReturnType<typeof runDeploy>>
>;
export type RunDeployMutationBody = ThreadServiceDeployBody;
export type RunDeployMutationError = AxiosError<RpcStatus>;

/**
 * @summary Deploys the thread's config customizations to the agent template.
 */
export const useRunDeploy = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runDeploy>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceDeployBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runDeploy>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDeployBody;
  },
  TContext
> => {
  const mutationOptions = getRunDeployMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * After reset, the thread will use the agent's default generator and config.
 * @summary ============================================================================
Reset & Deploy
============================================================================
Resets all per-thread config customizations to agent defaults.
 */
export const runResetConfig = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceResetConfigBody: ThreadServiceResetConfigBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ResetConfigResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/agent:reset`,
    threadServiceResetConfigBody,
    options,
  );
};

export const getRunResetConfigMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runResetConfig>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceResetConfigBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runResetConfig>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceResetConfigBody;
  },
  TContext
> => {
  const mutationKey = ['runResetConfig'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runResetConfig>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceResetConfigBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runResetConfig(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunResetConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof runResetConfig>>
>;
export type RunResetConfigMutationBody = ThreadServiceResetConfigBody;
export type RunResetConfigMutationError = AxiosError<RpcStatus>;

/**
 * @summary ============================================================================
Reset & Deploy
============================================================================
Resets all per-thread config customizations to agent defaults.
 */
export const useRunResetConfig = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runResetConfig>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceResetConfigBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runResetConfig>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceResetConfigBody;
  },
  TContext
> => {
  const mutationOptions = getRunResetConfigMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Threads are version-pinned at creation time and only this explicit
call moves them. The thread's per-thread template-group overrides
survive verbatim; the new version becomes the base they layer
onto. Downgrades and same-version targets are rejected. If the
target template requires variables the thread doesn't carry, the
response's `missing_variables` is populated and no state is
mutated — the caller re-prompts and re-issues.
 * @summary Moves a thread's pin to a different agent version.
 */
export const runUpgradeThread = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceUpgradeThreadBody: ThreadServiceUpgradeThreadBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1UpgradeThreadResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/agent:upgrade`,
    threadServiceUpgradeThreadBody,
    options,
  );
};

export const getRunUpgradeThreadMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runUpgradeThread>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceUpgradeThreadBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runUpgradeThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceUpgradeThreadBody;
  },
  TContext
> => {
  const mutationKey = ['runUpgradeThread'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runUpgradeThread>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceUpgradeThreadBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runUpgradeThread(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunUpgradeThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof runUpgradeThread>>
>;
export type RunUpgradeThreadMutationBody = ThreadServiceUpgradeThreadBody;
export type RunUpgradeThreadMutationError = AxiosError<RpcStatus>;

/**
 * @summary Moves a thread's pin to a different agent version.
 */
export const useRunUpgradeThread = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runUpgradeThread>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceUpgradeThreadBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runUpgradeThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceUpgradeThreadBody;
  },
  TContext
> => {
  const mutationOptions = getRunUpgradeThreadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary ============================================================================
Artifact CRUD (Thread-Scoped)
============================================================================
Lists artifacts with optional filters.
Supports S3-style delimiter for folder navigation.
Thread ID is required for variable-scoped artifact access.
 */
export const runListArtifacts = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunListArtifactsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListArtifactsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/artifacts`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRunListArtifactsQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  run?: string,
  agentId?: string,
  threadId?: string,
  params?: RunListArtifactsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/artifacts`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRunListArtifactsQueryOptions = <
  TData = Awaited<ReturnType<typeof runListArtifacts>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunListArtifactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runListArtifacts>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRunListArtifactsQueryKey(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof runListArtifacts>>
  > = ({ signal }) =>
    runListArtifacts(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(
      organization &&
      workspace &&
      automation &&
      run &&
      agentId &&
      threadId
    ),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof runListArtifacts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RunListArtifactsQueryResult = NonNullable<
  Awaited<ReturnType<typeof runListArtifacts>>
>;
export type RunListArtifactsQueryError = AxiosError<RpcStatus>;

export function useRunListArtifacts<
  TData = Awaited<ReturnType<typeof runListArtifacts>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params: undefined | RunListArtifactsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runListArtifacts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof runListArtifacts>>,
          TError,
          Awaited<ReturnType<typeof runListArtifacts>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunListArtifacts<
  TData = Awaited<ReturnType<typeof runListArtifacts>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunListArtifactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runListArtifacts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof runListArtifacts>>,
          TError,
          Awaited<ReturnType<typeof runListArtifacts>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunListArtifacts<
  TData = Awaited<ReturnType<typeof runListArtifacts>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunListArtifactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runListArtifacts>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ============================================================================
Artifact CRUD (Thread-Scoped)
============================================================================
Lists artifacts with optional filters.
Supports S3-style delimiter for folder navigation.
Thread ID is required for variable-scoped artifact access.
 */

export function useRunListArtifacts<
  TData = Awaited<ReturnType<typeof runListArtifacts>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunListArtifactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runListArtifacts>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRunListArtifactsQueryOptions(
    organization,
    workspace,
    automation,
    run,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Gets artifact metadata by URI.
 */
export const runGetArtifact = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: RunGetArtifactParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Artifact>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/artifacts/${artifactUri}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRunGetArtifactQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  run?: string,
  agentId?: string,
  threadId?: string,
  artifactUri?: string,
  params?: RunGetArtifactParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/artifacts/${artifactUri}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRunGetArtifactQueryOptions = <
  TData = Awaited<ReturnType<typeof runGetArtifact>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: RunGetArtifactParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof runGetArtifact>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRunGetArtifactQueryKey(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      artifactUri,
      params,
    );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof runGetArtifact>>> = ({
    signal,
  }) =>
    runGetArtifact(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      artifactUri,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(
      organization &&
      workspace &&
      automation &&
      run &&
      agentId &&
      threadId &&
      artifactUri
    ),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof runGetArtifact>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RunGetArtifactQueryResult = NonNullable<
  Awaited<ReturnType<typeof runGetArtifact>>
>;
export type RunGetArtifactQueryError = AxiosError<RpcStatus>;

export function useRunGetArtifact<
  TData = Awaited<ReturnType<typeof runGetArtifact>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params: undefined | RunGetArtifactParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof runGetArtifact>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetArtifact>>,
          TError,
          Awaited<ReturnType<typeof runGetArtifact>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetArtifact<
  TData = Awaited<ReturnType<typeof runGetArtifact>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: RunGetArtifactParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof runGetArtifact>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetArtifact>>,
          TError,
          Awaited<ReturnType<typeof runGetArtifact>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetArtifact<
  TData = Awaited<ReturnType<typeof runGetArtifact>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: RunGetArtifactParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof runGetArtifact>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets artifact metadata by URI.
 */

export function useRunGetArtifact<
  TData = Awaited<ReturnType<typeof runGetArtifact>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: RunGetArtifactParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof runGetArtifact>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRunGetArtifactQueryOptions(
    organization,
    workspace,
    automation,
    run,
    agentId,
    threadId,
    artifactUri,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Deletes an artifact by URI.
 */
export const runDeleteArtifact = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: RunDeleteArtifactParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RunDeleteArtifact200>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/artifacts/${artifactUri}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRunDeleteArtifactMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runDeleteArtifact>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      artifactUri: string;
      params?: RunDeleteArtifactParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runDeleteArtifact>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    artifactUri: string;
    params?: RunDeleteArtifactParams;
  },
  TContext
> => {
  const mutationKey = ['runDeleteArtifact'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runDeleteArtifact>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      artifactUri: string;
      params?: RunDeleteArtifactParams;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      artifactUri,
      params,
    } = props ?? {};

    return runDeleteArtifact(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      artifactUri,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunDeleteArtifactMutationResult = NonNullable<
  Awaited<ReturnType<typeof runDeleteArtifact>>
>;

export type RunDeleteArtifactMutationError = AxiosError<RpcStatus>;

/**
 * @summary Deletes an artifact by URI.
 */
export const useRunDeleteArtifact = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runDeleteArtifact>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        artifactUri: string;
        params?: RunDeleteArtifactParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runDeleteArtifact>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    artifactUri: string;
    params?: RunDeleteArtifactParams;
  },
  TContext
> => {
  const mutationOptions = getRunDeleteArtifactMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Creates or updates an artifact.
 */
export const runUpdateArtifact = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  threadServiceUpdateArtifactBody: ThreadServiceUpdateArtifactBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Artifact>> => {
  return axios.default.put(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/artifacts/${artifactUri}`,
    threadServiceUpdateArtifactBody,
    options,
  );
};

export const getRunUpdateArtifactMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runUpdateArtifact>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      artifactUri: string;
      data: ThreadServiceUpdateArtifactBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runUpdateArtifact>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    artifactUri: string;
    data: ThreadServiceUpdateArtifactBody;
  },
  TContext
> => {
  const mutationKey = ['runUpdateArtifact'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runUpdateArtifact>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      artifactUri: string;
      data: ThreadServiceUpdateArtifactBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      artifactUri,
      data,
    } = props ?? {};

    return runUpdateArtifact(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      artifactUri,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunUpdateArtifactMutationResult = NonNullable<
  Awaited<ReturnType<typeof runUpdateArtifact>>
>;
export type RunUpdateArtifactMutationBody = ThreadServiceUpdateArtifactBody;
export type RunUpdateArtifactMutationError = AxiosError<RpcStatus>;

/**
 * @summary Creates or updates an artifact.
 */
export const useRunUpdateArtifact = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runUpdateArtifact>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        artifactUri: string;
        data: ThreadServiceUpdateArtifactBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runUpdateArtifact>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    artifactUri: string;
    data: ThreadServiceUpdateArtifactBody;
  },
  TContext
> => {
  const mutationOptions = getRunUpdateArtifactMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Gets artifact content by URI.
 */
export const runGetArtifactContent = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: RunGetArtifactContentParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ArtifactContentResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/artifacts/${artifactUri}:content`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRunGetArtifactContentQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  run?: string,
  agentId?: string,
  threadId?: string,
  artifactUri?: string,
  params?: RunGetArtifactContentParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/artifacts/${artifactUri}:content`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRunGetArtifactContentQueryOptions = <
  TData = Awaited<ReturnType<typeof runGetArtifactContent>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: RunGetArtifactContentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetArtifactContent>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRunGetArtifactContentQueryKey(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      artifactUri,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof runGetArtifactContent>>
  > = ({ signal }) =>
    runGetArtifactContent(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      artifactUri,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(
      organization &&
      workspace &&
      automation &&
      run &&
      agentId &&
      threadId &&
      artifactUri
    ),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof runGetArtifactContent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RunGetArtifactContentQueryResult = NonNullable<
  Awaited<ReturnType<typeof runGetArtifactContent>>
>;
export type RunGetArtifactContentQueryError = AxiosError<RpcStatus>;

export function useRunGetArtifactContent<
  TData = Awaited<ReturnType<typeof runGetArtifactContent>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params: undefined | RunGetArtifactContentParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetArtifactContent>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetArtifactContent>>,
          TError,
          Awaited<ReturnType<typeof runGetArtifactContent>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetArtifactContent<
  TData = Awaited<ReturnType<typeof runGetArtifactContent>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: RunGetArtifactContentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetArtifactContent>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetArtifactContent>>,
          TError,
          Awaited<ReturnType<typeof runGetArtifactContent>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetArtifactContent<
  TData = Awaited<ReturnType<typeof runGetArtifactContent>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: RunGetArtifactContentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetArtifactContent>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets artifact content by URI.
 */

export function useRunGetArtifactContent<
  TData = Awaited<ReturnType<typeof runGetArtifactContent>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: RunGetArtifactContentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetArtifactContent>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRunGetArtifactContentQueryOptions(
    organization,
    workspace,
    automation,
    run,
    agentId,
    threadId,
    artifactUri,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the unified diff for a specific artifact if it has staged changes.
Returns empty diff for binary files or if no changes exist.
 * @summary Gets the diff for a single staged artifact.
 */
export const runGetArtifactDiff = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: RunGetArtifactDiffParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetArtifactDiffResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/artifacts/${artifactUri}:diff`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRunGetArtifactDiffQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  run?: string,
  agentId?: string,
  threadId?: string,
  artifactUri?: string,
  params?: RunGetArtifactDiffParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/artifacts/${artifactUri}:diff`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRunGetArtifactDiffQueryOptions = <
  TData = Awaited<ReturnType<typeof runGetArtifactDiff>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: RunGetArtifactDiffParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetArtifactDiff>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRunGetArtifactDiffQueryKey(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      artifactUri,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof runGetArtifactDiff>>
  > = ({ signal }) =>
    runGetArtifactDiff(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      artifactUri,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(
      organization &&
      workspace &&
      automation &&
      run &&
      agentId &&
      threadId &&
      artifactUri
    ),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof runGetArtifactDiff>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RunGetArtifactDiffQueryResult = NonNullable<
  Awaited<ReturnType<typeof runGetArtifactDiff>>
>;
export type RunGetArtifactDiffQueryError = AxiosError<RpcStatus>;

export function useRunGetArtifactDiff<
  TData = Awaited<ReturnType<typeof runGetArtifactDiff>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params: undefined | RunGetArtifactDiffParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetArtifactDiff>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetArtifactDiff>>,
          TError,
          Awaited<ReturnType<typeof runGetArtifactDiff>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetArtifactDiff<
  TData = Awaited<ReturnType<typeof runGetArtifactDiff>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: RunGetArtifactDiffParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetArtifactDiff>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetArtifactDiff>>,
          TError,
          Awaited<ReturnType<typeof runGetArtifactDiff>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetArtifactDiff<
  TData = Awaited<ReturnType<typeof runGetArtifactDiff>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: RunGetArtifactDiffParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetArtifactDiff>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets the diff for a single staged artifact.
 */

export function useRunGetArtifactDiff<
  TData = Awaited<ReturnType<typeof runGetArtifactDiff>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  artifactUri: string,
  params?: RunGetArtifactDiffParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetArtifactDiff>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRunGetArtifactDiffQueryOptions(
    organization,
    workspace,
    automation,
    run,
    agentId,
    threadId,
    artifactUri,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Persists all staged changes (additions, modifications, deletions) to
the underlying store. For stores without staging, this is a no-op.
 * @summary Commits staged artifact changes to the underlying store.
 */
export const runCommitArtifacts = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceCommitArtifactsBody: ThreadServiceCommitArtifactsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1CommitArtifactsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/artifacts:commit`,
    threadServiceCommitArtifactsBody,
    options,
  );
};

export const getRunCommitArtifactsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runCommitArtifacts>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceCommitArtifactsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runCommitArtifacts>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceCommitArtifactsBody;
  },
  TContext
> => {
  const mutationKey = ['runCommitArtifacts'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runCommitArtifacts>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceCommitArtifactsBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runCommitArtifacts(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunCommitArtifactsMutationResult = NonNullable<
  Awaited<ReturnType<typeof runCommitArtifacts>>
>;
export type RunCommitArtifactsMutationBody = ThreadServiceCommitArtifactsBody;
export type RunCommitArtifactsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Commits staged artifact changes to the underlying store.
 */
export const useRunCommitArtifacts = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runCommitArtifacts>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceCommitArtifactsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runCommitArtifacts>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceCommitArtifactsBody;
  },
  TContext
> => {
  const mutationOptions = getRunCommitArtifactsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns information about artifacts that have been modified but not yet
committed. For stores with staging enabled, this shows pending changes.
For stores without staging, returns an empty response.
 * @summary Gets staged artifact changes with optional diff content.
 */
export const runDiffArtifacts = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceDiffArtifactsBody: ThreadServiceDiffArtifactsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1DiffArtifactsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/artifacts:diff`,
    threadServiceDiffArtifactsBody,
    options,
  );
};

export const getRunDiffArtifactsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runDiffArtifacts>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDiffArtifactsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runDiffArtifacts>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDiffArtifactsBody;
  },
  TContext
> => {
  const mutationKey = ['runDiffArtifacts'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runDiffArtifacts>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDiffArtifactsBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runDiffArtifacts(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunDiffArtifactsMutationResult = NonNullable<
  Awaited<ReturnType<typeof runDiffArtifacts>>
>;
export type RunDiffArtifactsMutationBody = ThreadServiceDiffArtifactsBody;
export type RunDiffArtifactsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Gets staged artifact changes with optional diff content.
 */
export const useRunDiffArtifacts = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runDiffArtifacts>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceDiffArtifactsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runDiffArtifacts>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDiffArtifactsBody;
  },
  TContext
> => {
  const mutationOptions = getRunDiffArtifactsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Clears all pending changes (additions, modifications, deletions) from
the staging area. For stores without staging, this is a no-op.
 * @summary Discards all staged artifact changes without committing.
 */
export const runDiscardArtifacts = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceDiscardArtifactsBody: ThreadServiceDiscardArtifactsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1DiscardArtifactsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/artifacts:discard`,
    threadServiceDiscardArtifactsBody,
    options,
  );
};

export const getRunDiscardArtifactsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runDiscardArtifacts>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDiscardArtifactsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runDiscardArtifacts>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDiscardArtifactsBody;
  },
  TContext
> => {
  const mutationKey = ['runDiscardArtifacts'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runDiscardArtifacts>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDiscardArtifactsBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runDiscardArtifacts(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunDiscardArtifactsMutationResult = NonNullable<
  Awaited<ReturnType<typeof runDiscardArtifacts>>
>;
export type RunDiscardArtifactsMutationBody = ThreadServiceDiscardArtifactsBody;
export type RunDiscardArtifactsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Discards all staged artifact changes without committing.
 */
export const useRunDiscardArtifacts = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runDiscardArtifacts>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceDiscardArtifactsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runDiscardArtifacts>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDiscardArtifactsBody;
  },
  TContext
> => {
  const mutationOptions = getRunDiscardArtifactsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary ============================================================================
Search (Thread-Scoped)
============================================================================
Searches artifact contents using regex pattern matching.
 */
export const runGrepArtifacts = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceGrepArtifactsBody: ThreadServiceGrepArtifactsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GrepArtifactsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/artifacts:grep`,
    threadServiceGrepArtifactsBody,
    options,
  );
};

export const getRunGrepArtifactsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runGrepArtifacts>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceGrepArtifactsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runGrepArtifacts>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceGrepArtifactsBody;
  },
  TContext
> => {
  const mutationKey = ['runGrepArtifacts'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runGrepArtifacts>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceGrepArtifactsBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runGrepArtifacts(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunGrepArtifactsMutationResult = NonNullable<
  Awaited<ReturnType<typeof runGrepArtifacts>>
>;
export type RunGrepArtifactsMutationBody = ThreadServiceGrepArtifactsBody;
export type RunGrepArtifactsMutationError = AxiosError<RpcStatus>;

/**
 * @summary ============================================================================
Search (Thread-Scoped)
============================================================================
Searches artifact contents using regex pattern matching.
 */
export const useRunGrepArtifacts = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runGrepArtifacts>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceGrepArtifactsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runGrepArtifacts>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceGrepArtifactsBody;
  },
  TContext
> => {
  const mutationOptions = getRunGrepArtifactsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns a lightweight summary of pending changes including counts and
change metadata without diff content. Use DiffArtifacts for full diffs.
 * @summary ============================================================================
Staging (Thread-Scoped)
============================================================================
Gets a summary of staged artifact changes.
 */
export const runGetArtifactsStagingSummary = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetArtifactsStagingSummaryParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetArtifactsStagingSummaryResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/artifacts:staging`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRunGetArtifactsStagingSummaryQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  run?: string,
  agentId?: string,
  threadId?: string,
  params?: RunGetArtifactsStagingSummaryParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/artifacts:staging`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRunGetArtifactsStagingSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof runGetArtifactsStagingSummary>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetArtifactsStagingSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetArtifactsStagingSummary>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRunGetArtifactsStagingSummaryQueryKey(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof runGetArtifactsStagingSummary>>
  > = ({ signal }) =>
    runGetArtifactsStagingSummary(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(
      organization &&
      workspace &&
      automation &&
      run &&
      agentId &&
      threadId
    ),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof runGetArtifactsStagingSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RunGetArtifactsStagingSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof runGetArtifactsStagingSummary>>
>;
export type RunGetArtifactsStagingSummaryQueryError = AxiosError<RpcStatus>;

export function useRunGetArtifactsStagingSummary<
  TData = Awaited<ReturnType<typeof runGetArtifactsStagingSummary>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params: undefined | RunGetArtifactsStagingSummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetArtifactsStagingSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetArtifactsStagingSummary>>,
          TError,
          Awaited<ReturnType<typeof runGetArtifactsStagingSummary>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetArtifactsStagingSummary<
  TData = Awaited<ReturnType<typeof runGetArtifactsStagingSummary>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetArtifactsStagingSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetArtifactsStagingSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetArtifactsStagingSummary>>,
          TError,
          Awaited<ReturnType<typeof runGetArtifactsStagingSummary>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetArtifactsStagingSummary<
  TData = Awaited<ReturnType<typeof runGetArtifactsStagingSummary>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetArtifactsStagingSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetArtifactsStagingSummary>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ============================================================================
Staging (Thread-Scoped)
============================================================================
Gets a summary of staged artifact changes.
 */

export function useRunGetArtifactsStagingSummary<
  TData = Awaited<ReturnType<typeof runGetArtifactsStagingSummary>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetArtifactsStagingSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetArtifactsStagingSummary>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRunGetArtifactsStagingSummaryQueryOptions(
    organization,
    workspace,
    automation,
    run,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a unified view of all items contributing to the context window:
- Memory blocks (fixed and volatile)
- Enabled tools (fixed)
- Conversation history (compactable)

Each item includes its token count for context budget management.
 * @summary ============================================================================
Context Information (Thread-Scoped)
============================================================================
Gets thread context information including all context items with token counts.
 */
export const runGetThreadContext = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetThreadContextParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetThreadContextResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/context`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRunGetThreadContextQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  run?: string,
  agentId?: string,
  threadId?: string,
  params?: RunGetThreadContextParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/context`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRunGetThreadContextQueryOptions = <
  TData = Awaited<ReturnType<typeof runGetThreadContext>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetThreadContextParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetThreadContext>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRunGetThreadContextQueryKey(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof runGetThreadContext>>
  > = ({ signal }) =>
    runGetThreadContext(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(
      organization &&
      workspace &&
      automation &&
      run &&
      agentId &&
      threadId
    ),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof runGetThreadContext>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RunGetThreadContextQueryResult = NonNullable<
  Awaited<ReturnType<typeof runGetThreadContext>>
>;
export type RunGetThreadContextQueryError = AxiosError<RpcStatus>;

export function useRunGetThreadContext<
  TData = Awaited<ReturnType<typeof runGetThreadContext>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params: undefined | RunGetThreadContextParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetThreadContext>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetThreadContext>>,
          TError,
          Awaited<ReturnType<typeof runGetThreadContext>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetThreadContext<
  TData = Awaited<ReturnType<typeof runGetThreadContext>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetThreadContextParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetThreadContext>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetThreadContext>>,
          TError,
          Awaited<ReturnType<typeof runGetThreadContext>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetThreadContext<
  TData = Awaited<ReturnType<typeof runGetThreadContext>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetThreadContextParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetThreadContext>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ============================================================================
Context Information (Thread-Scoped)
============================================================================
Gets thread context information including all context items with token counts.
 */

export function useRunGetThreadContext<
  TData = Awaited<ReturnType<typeof runGetThreadContext>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetThreadContextParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetThreadContext>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRunGetThreadContextQueryOptions(
    organization,
    workspace,
    automation,
    run,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Prices the thread's usage aggregate (and its sub-agent delegations)
against the current effective-dated rate card. USD is computed at read
time, never stored.
 * @summary Gets a thread's cost summary.
 */
export const runGetThreadCostSummary = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetThreadCostSummaryParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ThreadCostSummary>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/cost`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRunGetThreadCostSummaryQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  run?: string,
  agentId?: string,
  threadId?: string,
  params?: RunGetThreadCostSummaryParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/cost`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRunGetThreadCostSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof runGetThreadCostSummary>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetThreadCostSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetThreadCostSummary>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRunGetThreadCostSummaryQueryKey(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof runGetThreadCostSummary>>
  > = ({ signal }) =>
    runGetThreadCostSummary(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(
      organization &&
      workspace &&
      automation &&
      run &&
      agentId &&
      threadId
    ),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof runGetThreadCostSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RunGetThreadCostSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof runGetThreadCostSummary>>
>;
export type RunGetThreadCostSummaryQueryError = AxiosError<RpcStatus>;

export function useRunGetThreadCostSummary<
  TData = Awaited<ReturnType<typeof runGetThreadCostSummary>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params: undefined | RunGetThreadCostSummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetThreadCostSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetThreadCostSummary>>,
          TError,
          Awaited<ReturnType<typeof runGetThreadCostSummary>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetThreadCostSummary<
  TData = Awaited<ReturnType<typeof runGetThreadCostSummary>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetThreadCostSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetThreadCostSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetThreadCostSummary>>,
          TError,
          Awaited<ReturnType<typeof runGetThreadCostSummary>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetThreadCostSummary<
  TData = Awaited<ReturnType<typeof runGetThreadCostSummary>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetThreadCostSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetThreadCostSummary>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets a thread's cost summary.
 */

export function useRunGetThreadCostSummary<
  TData = Awaited<ReturnType<typeof runGetThreadCostSummary>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetThreadCostSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetThreadCostSummary>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRunGetThreadCostSummaryQueryOptions(
    organization,
    workspace,
    automation,
    run,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deliberately uncached so the Deploy gate stays fresh.
Returns NOT_FOUND if the thread doesn't exist.
 * @summary Reports the thread's per-thread config customizations in one read:
whether Deploy has anything to promote, which sections are
customized, and whether generated card state is present.
 */
export const runGetThreadCustomizations = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetThreadCustomizationsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ThreadCustomizationsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/customizations`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRunGetThreadCustomizationsQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  run?: string,
  agentId?: string,
  threadId?: string,
  params?: RunGetThreadCustomizationsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/customizations`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRunGetThreadCustomizationsQueryOptions = <
  TData = Awaited<ReturnType<typeof runGetThreadCustomizations>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetThreadCustomizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetThreadCustomizations>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRunGetThreadCustomizationsQueryKey(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof runGetThreadCustomizations>>
  > = ({ signal }) =>
    runGetThreadCustomizations(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(
      organization &&
      workspace &&
      automation &&
      run &&
      agentId &&
      threadId
    ),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof runGetThreadCustomizations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RunGetThreadCustomizationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof runGetThreadCustomizations>>
>;
export type RunGetThreadCustomizationsQueryError = AxiosError<RpcStatus>;

export function useRunGetThreadCustomizations<
  TData = Awaited<ReturnType<typeof runGetThreadCustomizations>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params: undefined | RunGetThreadCustomizationsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetThreadCustomizations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetThreadCustomizations>>,
          TError,
          Awaited<ReturnType<typeof runGetThreadCustomizations>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetThreadCustomizations<
  TData = Awaited<ReturnType<typeof runGetThreadCustomizations>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetThreadCustomizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetThreadCustomizations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetThreadCustomizations>>,
          TError,
          Awaited<ReturnType<typeof runGetThreadCustomizations>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetThreadCustomizations<
  TData = Awaited<ReturnType<typeof runGetThreadCustomizations>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetThreadCustomizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetThreadCustomizations>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Reports the thread's per-thread config customizations in one read:
whether Deploy has anything to promote, which sections are
customized, and whether generated card state is present.
 */

export function useRunGetThreadCustomizations<
  TData = Awaited<ReturnType<typeof runGetThreadCustomizations>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetThreadCustomizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetThreadCustomizations>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRunGetThreadCustomizationsQueryOptions(
    organization,
    workspace,
    automation,
    run,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The thread context is required because the embedder may depend on
variables that are resolved per-thread. Returns dimension, max input
length, normalization, and provider information. Returns NOT_FOUND if
the agent has no embedder configured.
 * @summary Gets embedder information and capabilities for the agent's embedder.
 */
export const runGetEmbedderInfo = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetEmbedderInfoParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1EmbedderInfo>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/embedder-info`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRunGetEmbedderInfoQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  run?: string,
  agentId?: string,
  threadId?: string,
  params?: RunGetEmbedderInfoParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/embedder-info`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRunGetEmbedderInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof runGetEmbedderInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetEmbedderInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetEmbedderInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRunGetEmbedderInfoQueryKey(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof runGetEmbedderInfo>>
  > = ({ signal }) =>
    runGetEmbedderInfo(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(
      organization &&
      workspace &&
      automation &&
      run &&
      agentId &&
      threadId
    ),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof runGetEmbedderInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RunGetEmbedderInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof runGetEmbedderInfo>>
>;
export type RunGetEmbedderInfoQueryError = AxiosError<RpcStatus>;

export function useRunGetEmbedderInfo<
  TData = Awaited<ReturnType<typeof runGetEmbedderInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params: undefined | RunGetEmbedderInfoParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetEmbedderInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetEmbedderInfo>>,
          TError,
          Awaited<ReturnType<typeof runGetEmbedderInfo>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetEmbedderInfo<
  TData = Awaited<ReturnType<typeof runGetEmbedderInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetEmbedderInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetEmbedderInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetEmbedderInfo>>,
          TError,
          Awaited<ReturnType<typeof runGetEmbedderInfo>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetEmbedderInfo<
  TData = Awaited<ReturnType<typeof runGetEmbedderInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetEmbedderInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetEmbedderInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets embedder information and capabilities for the agent's embedder.
 */

export function useRunGetEmbedderInfo<
  TData = Awaited<ReturnType<typeof runGetEmbedderInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetEmbedderInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetEmbedderInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRunGetEmbedderInfoQueryOptions(
    organization,
    workspace,
    automation,
    run,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Generates an embedding for a single audio clip.
 */
export const runEmbedAudio = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceEmbedAudioBody: ThreadServiceEmbedAudioBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1EmbedResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/embedder:embed-audio`,
    threadServiceEmbedAudioBody,
    options,
  );
};

export const getRunEmbedAudioMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runEmbedAudio>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedAudioBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runEmbedAudio>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedAudioBody;
  },
  TContext
> => {
  const mutationKey = ['runEmbedAudio'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runEmbedAudio>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedAudioBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runEmbedAudio(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunEmbedAudioMutationResult = NonNullable<
  Awaited<ReturnType<typeof runEmbedAudio>>
>;
export type RunEmbedAudioMutationBody = ThreadServiceEmbedAudioBody;
export type RunEmbedAudioMutationError = AxiosError<RpcStatus>;

/**
 * @summary Generates an embedding for a single audio clip.
 */
export const useRunEmbedAudio = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runEmbedAudio>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceEmbedAudioBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runEmbedAudio>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedAudioBody;
  },
  TContext
> => {
  const mutationOptions = getRunEmbedAudioMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Generates embeddings for a batch of audio clips.
 */
export const runEmbedAudioBatch = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceEmbedAudioBatchBody: ThreadServiceEmbedAudioBatchBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1EmbedBatchResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/embedder:embed-audio-batch`,
    threadServiceEmbedAudioBatchBody,
    options,
  );
};

export const getRunEmbedAudioBatchMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runEmbedAudioBatch>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedAudioBatchBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runEmbedAudioBatch>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedAudioBatchBody;
  },
  TContext
> => {
  const mutationKey = ['runEmbedAudioBatch'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runEmbedAudioBatch>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedAudioBatchBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runEmbedAudioBatch(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunEmbedAudioBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof runEmbedAudioBatch>>
>;
export type RunEmbedAudioBatchMutationBody = ThreadServiceEmbedAudioBatchBody;
export type RunEmbedAudioBatchMutationError = AxiosError<RpcStatus>;

/**
 * @summary Generates embeddings for a batch of audio clips.
 */
export const useRunEmbedAudioBatch = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runEmbedAudioBatch>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceEmbedAudioBatchBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runEmbedAudioBatch>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedAudioBatchBody;
  },
  TContext
> => {
  const mutationOptions = getRunEmbedAudioBatchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Generates an embedding for a single image (encoded bytes).
 */
export const runEmbedImage = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceEmbedImageBody: ThreadServiceEmbedImageBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1EmbedResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/embedder:embed-image`,
    threadServiceEmbedImageBody,
    options,
  );
};

export const getRunEmbedImageMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runEmbedImage>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedImageBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runEmbedImage>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedImageBody;
  },
  TContext
> => {
  const mutationKey = ['runEmbedImage'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runEmbedImage>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedImageBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runEmbedImage(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunEmbedImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof runEmbedImage>>
>;
export type RunEmbedImageMutationBody = ThreadServiceEmbedImageBody;
export type RunEmbedImageMutationError = AxiosError<RpcStatus>;

/**
 * @summary Generates an embedding for a single image (encoded bytes).
 */
export const useRunEmbedImage = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runEmbedImage>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceEmbedImageBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runEmbedImage>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedImageBody;
  },
  TContext
> => {
  const mutationOptions = getRunEmbedImageMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Generates embeddings for a batch of images.
 */
export const runEmbedImageBatch = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceEmbedImageBatchBody: ThreadServiceEmbedImageBatchBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1EmbedBatchResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/embedder:embed-image-batch`,
    threadServiceEmbedImageBatchBody,
    options,
  );
};

export const getRunEmbedImageBatchMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runEmbedImageBatch>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedImageBatchBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runEmbedImageBatch>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedImageBatchBody;
  },
  TContext
> => {
  const mutationKey = ['runEmbedImageBatch'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runEmbedImageBatch>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedImageBatchBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runEmbedImageBatch(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunEmbedImageBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof runEmbedImageBatch>>
>;
export type RunEmbedImageBatchMutationBody = ThreadServiceEmbedImageBatchBody;
export type RunEmbedImageBatchMutationError = AxiosError<RpcStatus>;

/**
 * @summary Generates embeddings for a batch of images.
 */
export const useRunEmbedImageBatch = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runEmbedImageBatch>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceEmbedImageBatchBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runEmbedImageBatch>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedImageBatchBody;
  },
  TContext
> => {
  const mutationOptions = getRunEmbedImageBatchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns NOT_FOUND if the agent has no embedder configured, or
FAILED_PRECONDITION if the configured embedder doesn't support text.
 * @summary Generates an embedding for a single text input.
 */
export const runEmbedText = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceEmbedTextBody: ThreadServiceEmbedTextBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1EmbedResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/embedder:embed-text`,
    threadServiceEmbedTextBody,
    options,
  );
};

export const getRunEmbedTextMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runEmbedText>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedTextBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runEmbedText>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedTextBody;
  },
  TContext
> => {
  const mutationKey = ['runEmbedText'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runEmbedText>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedTextBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runEmbedText(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunEmbedTextMutationResult = NonNullable<
  Awaited<ReturnType<typeof runEmbedText>>
>;
export type RunEmbedTextMutationBody = ThreadServiceEmbedTextBody;
export type RunEmbedTextMutationError = AxiosError<RpcStatus>;

/**
 * @summary Generates an embedding for a single text input.
 */
export const useRunEmbedText = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runEmbedText>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceEmbedTextBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runEmbedText>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedTextBody;
  },
  TContext
> => {
  const mutationOptions = getRunEmbedTextMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Generates embeddings for a batch of text inputs.
 */
export const runEmbedTextBatch = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceEmbedTextBatchBody: ThreadServiceEmbedTextBatchBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1EmbedBatchResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/embedder:embed-text-batch`,
    threadServiceEmbedTextBatchBody,
    options,
  );
};

export const getRunEmbedTextBatchMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runEmbedTextBatch>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedTextBatchBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runEmbedTextBatch>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedTextBatchBody;
  },
  TContext
> => {
  const mutationKey = ['runEmbedTextBatch'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runEmbedTextBatch>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedTextBatchBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runEmbedTextBatch(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunEmbedTextBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof runEmbedTextBatch>>
>;
export type RunEmbedTextBatchMutationBody = ThreadServiceEmbedTextBatchBody;
export type RunEmbedTextBatchMutationError = AxiosError<RpcStatus>;

/**
 * @summary Generates embeddings for a batch of text inputs.
 */
export const useRunEmbedTextBatch = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runEmbedTextBatch>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceEmbedTextBatchBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runEmbedTextBatch>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedTextBatchBody;
  },
  TContext
> => {
  const mutationOptions = getRunEmbedTextBatchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Generates an embedding for a single video clip.
 */
export const runEmbedVideo = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceEmbedVideoBody: ThreadServiceEmbedVideoBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1EmbedResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/embedder:embed-video`,
    threadServiceEmbedVideoBody,
    options,
  );
};

export const getRunEmbedVideoMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runEmbedVideo>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedVideoBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runEmbedVideo>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedVideoBody;
  },
  TContext
> => {
  const mutationKey = ['runEmbedVideo'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runEmbedVideo>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedVideoBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runEmbedVideo(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunEmbedVideoMutationResult = NonNullable<
  Awaited<ReturnType<typeof runEmbedVideo>>
>;
export type RunEmbedVideoMutationBody = ThreadServiceEmbedVideoBody;
export type RunEmbedVideoMutationError = AxiosError<RpcStatus>;

/**
 * @summary Generates an embedding for a single video clip.
 */
export const useRunEmbedVideo = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runEmbedVideo>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceEmbedVideoBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runEmbedVideo>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedVideoBody;
  },
  TContext
> => {
  const mutationOptions = getRunEmbedVideoMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Generates embeddings for a batch of video clips.
 */
export const runEmbedVideoBatch = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceEmbedVideoBatchBody: ThreadServiceEmbedVideoBatchBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1EmbedBatchResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/embedder:embed-video-batch`,
    threadServiceEmbedVideoBatchBody,
    options,
  );
};

export const getRunEmbedVideoBatchMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runEmbedVideoBatch>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedVideoBatchBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runEmbedVideoBatch>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedVideoBatchBody;
  },
  TContext
> => {
  const mutationKey = ['runEmbedVideoBatch'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runEmbedVideoBatch>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceEmbedVideoBatchBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runEmbedVideoBatch(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunEmbedVideoBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof runEmbedVideoBatch>>
>;
export type RunEmbedVideoBatchMutationBody = ThreadServiceEmbedVideoBatchBody;
export type RunEmbedVideoBatchMutationError = AxiosError<RpcStatus>;

/**
 * @summary Generates embeddings for a batch of video clips.
 */
export const useRunEmbedVideoBatch = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runEmbedVideoBatch>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceEmbedVideoBatchBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runEmbedVideoBatch>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceEmbedVideoBatchBody;
  },
  TContext
> => {
  const mutationOptions = getRunEmbedVideoBatchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * This RPC returns the complete history of events for a thread, including
user inputs, assistant responses, tool calls, and their results.
Events are returned in chronological order.
 * @summary Retrieves all events from a thread.
 */
export const runGetEvents = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetEventsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetEventsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/events`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRunGetEventsQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  run?: string,
  agentId?: string,
  threadId?: string,
  params?: RunGetEventsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/events`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRunGetEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof runGetEvents>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof runGetEvents>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRunGetEventsQueryKey(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof runGetEvents>>> = ({
    signal,
  }) =>
    runGetEvents(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(
      organization &&
      workspace &&
      automation &&
      run &&
      agentId &&
      threadId
    ),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof runGetEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RunGetEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof runGetEvents>>
>;
export type RunGetEventsQueryError = AxiosError<RpcStatus>;

export function useRunGetEvents<
  TData = Awaited<ReturnType<typeof runGetEvents>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params: undefined | RunGetEventsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof runGetEvents>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetEvents>>,
          TError,
          Awaited<ReturnType<typeof runGetEvents>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetEvents<
  TData = Awaited<ReturnType<typeof runGetEvents>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof runGetEvents>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetEvents>>,
          TError,
          Awaited<ReturnType<typeof runGetEvents>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetEvents<
  TData = Awaited<ReturnType<typeof runGetEvents>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof runGetEvents>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieves all events from a thread.
 */

export function useRunGetEvents<
  TData = Awaited<ReturnType<typeof runGetEvents>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof runGetEvents>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRunGetEventsQueryOptions(
    organization,
    workspace,
    automation,
    run,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * This RPC adds user input to the specified thread and returns a stream
of events representing the assistant's response. Events include output text,
tool calls, and completion metadata.
 * @summary ============================================================================
Events
============================================================================
Sends a message and streams back response events synchronously.
 */
export const runSendMessageSync = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceSendMessageSyncBody: ThreadServiceSendMessageSyncBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RunSendMessageSync200>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/events`,
    threadServiceSendMessageSyncBody,
    options,
  );
};

export const getRunSendMessageSyncMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runSendMessageSync>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceSendMessageSyncBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runSendMessageSync>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceSendMessageSyncBody;
  },
  TContext
> => {
  const mutationKey = ['runSendMessageSync'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runSendMessageSync>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceSendMessageSyncBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runSendMessageSync(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunSendMessageSyncMutationResult = NonNullable<
  Awaited<ReturnType<typeof runSendMessageSync>>
>;
export type RunSendMessageSyncMutationBody = ThreadServiceSendMessageSyncBody;
export type RunSendMessageSyncMutationError = AxiosError<RpcStatus>;

/**
 * @summary ============================================================================
Events
============================================================================
Sends a message and streams back response events synchronously.
 */
export const useRunSendMessageSync = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runSendMessageSync>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceSendMessageSyncBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runSendMessageSync>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceSendMessageSyncBody;
  },
  TContext
> => {
  const mutationOptions = getRunSendMessageSyncMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Deletes an event and its entire associated turn from the thread.
 */
export const runDeleteEvent = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceDeleteEventBody: ThreadServiceDeleteEventBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1DeleteEventResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/events:delete`,
    threadServiceDeleteEventBody,
    options,
  );
};

export const getRunDeleteEventMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runDeleteEvent>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDeleteEventBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runDeleteEvent>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDeleteEventBody;
  },
  TContext
> => {
  const mutationKey = ['runDeleteEvent'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runDeleteEvent>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDeleteEventBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runDeleteEvent(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunDeleteEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof runDeleteEvent>>
>;
export type RunDeleteEventMutationBody = ThreadServiceDeleteEventBody;
export type RunDeleteEventMutationError = AxiosError<RpcStatus>;

/**
 * @summary Deletes an event and its entire associated turn from the thread.
 */
export const useRunDeleteEvent = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runDeleteEvent>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceDeleteEventBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runDeleteEvent>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDeleteEventBody;
  },
  TContext
> => {
  const mutationOptions = getRunDeleteEventMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Clears the entire event history and associated feedback while preserving
all other thread state (plan, memory customizations, config customizations, scratchpad).
Returns FAILED_PRECONDITION if the thread is currently generating.
 * @summary Resets all events and feedback in a thread.
 */
export const runResetEvents = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceResetEventsBody: ThreadServiceResetEventsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ResetEventsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/events:reset`,
    threadServiceResetEventsBody,
    options,
  );
};

export const getRunResetEventsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runResetEvents>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceResetEventsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runResetEvents>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceResetEventsBody;
  },
  TContext
> => {
  const mutationKey = ['runResetEvents'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runResetEvents>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceResetEventsBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runResetEvents(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunResetEventsMutationResult = NonNullable<
  Awaited<ReturnType<typeof runResetEvents>>
>;
export type RunResetEventsMutationBody = ThreadServiceResetEventsBody;
export type RunResetEventsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Resets all events and feedback in a thread.
 */
export const useRunResetEvents = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runResetEvents>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceResetEventsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runResetEvents>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceResetEventsBody;
  },
  TContext
> => {
  const mutationOptions = getRunResetEventsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Restores a previously deleted event and its entire associated turn.
 */
export const runRestoreEvent = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceRestoreEventBody: ThreadServiceRestoreEventBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1RestoreEventResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/events:restore`,
    threadServiceRestoreEventBody,
    options,
  );
};

export const getRunRestoreEventMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runRestoreEvent>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceRestoreEventBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runRestoreEvent>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceRestoreEventBody;
  },
  TContext
> => {
  const mutationKey = ['runRestoreEvent'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runRestoreEvent>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceRestoreEventBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runRestoreEvent(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunRestoreEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof runRestoreEvent>>
>;
export type RunRestoreEventMutationBody = ThreadServiceRestoreEventBody;
export type RunRestoreEventMutationError = AxiosError<RpcStatus>;

/**
 * @summary Restores a previously deleted event and its entire associated turn.
 */
export const useRunRestoreEvent = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runRestoreEvent>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceRestoreEventBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runRestoreEvent>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceRestoreEventBody;
  },
  TContext
> => {
  const mutationOptions = getRunRestoreEventMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Feedback is mutually exclusive - setting LIKE removes any DISLIKE and vice versa.
Setting the same feedback that already exists is a no-op.
Use FEEDBACK_TYPE_UNSPECIFIED to clear existing feedback.

Feedback is stored with the thread and is purely for analytics/UI purposes.
It is not visible to the LLM.
 * @summary ============================================================================
Feedback
============================================================================
Sets feedback (like/dislike) for a generation response.
 */
export const runSetFeedback = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceSetFeedbackBody: ThreadServiceSetFeedbackBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1SetFeedbackResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/feedback`,
    threadServiceSetFeedbackBody,
    options,
  );
};

export const getRunSetFeedbackMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runSetFeedback>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceSetFeedbackBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runSetFeedback>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceSetFeedbackBody;
  },
  TContext
> => {
  const mutationKey = ['runSetFeedback'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runSetFeedback>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceSetFeedbackBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runSetFeedback(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunSetFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof runSetFeedback>>
>;
export type RunSetFeedbackMutationBody = ThreadServiceSetFeedbackBody;
export type RunSetFeedbackMutationError = AxiosError<RpcStatus>;

/**
 * @summary ============================================================================
Feedback
============================================================================
Sets feedback (like/dislike) for a generation response.
 */
export const useRunSetFeedback = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runSetFeedback>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceSetFeedbackBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runSetFeedback>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceSetFeedbackBody;
  },
  TContext
> => {
  const mutationOptions = getRunSetFeedbackMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * The thread context is required because the generator may depend on
variables that are resolved per-thread. Returns model capabilities
like supported features, token limits, and pricing information.
 * @summary ============================================================================
Model Info (Thread-Scoped)
============================================================================
Gets model information and capabilities for the agent's main generator.
 */
export const runGetModelInfo = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetModelInfoParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ModelInfo>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/generator:model-info`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRunGetModelInfoQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  run?: string,
  agentId?: string,
  threadId?: string,
  params?: RunGetModelInfoParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/generator:model-info`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRunGetModelInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof runGetModelInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetModelInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetModelInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRunGetModelInfoQueryKey(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof runGetModelInfo>>> = ({
    signal,
  }) =>
    runGetModelInfo(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(
      organization &&
      workspace &&
      automation &&
      run &&
      agentId &&
      threadId
    ),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof runGetModelInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RunGetModelInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof runGetModelInfo>>
>;
export type RunGetModelInfoQueryError = AxiosError<RpcStatus>;

export function useRunGetModelInfo<
  TData = Awaited<ReturnType<typeof runGetModelInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params: undefined | RunGetModelInfoParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetModelInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetModelInfo>>,
          TError,
          Awaited<ReturnType<typeof runGetModelInfo>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetModelInfo<
  TData = Awaited<ReturnType<typeof runGetModelInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetModelInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetModelInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetModelInfo>>,
          TError,
          Awaited<ReturnType<typeof runGetModelInfo>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetModelInfo<
  TData = Awaited<ReturnType<typeof runGetModelInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetModelInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetModelInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ============================================================================
Model Info (Thread-Scoped)
============================================================================
Gets model information and capabilities for the agent's main generator.
 */

export function useRunGetModelInfo<
  TData = Awaited<ReturnType<typeof runGetModelInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetModelInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetModelInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRunGetModelInfoQueryOptions(
    organization,
    workspace,
    automation,
    run,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The message is added to the thread and generation begins asynchronously.
Response events arrive via SubscribeThread stream or SSE, not this RPC.
 * @summary Sends a message to a thread (fire and forget).
 */
export const runSendMessage = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceSendMessageBody: ThreadServiceSendMessageBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1SendMessageResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/input`,
    threadServiceSendMessageBody,
    options,
  );
};

export const getRunSendMessageMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runSendMessage>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceSendMessageBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runSendMessage>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceSendMessageBody;
  },
  TContext
> => {
  const mutationKey = ['runSendMessage'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runSendMessage>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceSendMessageBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runSendMessage(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunSendMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof runSendMessage>>
>;
export type RunSendMessageMutationBody = ThreadServiceSendMessageBody;
export type RunSendMessageMutationError = AxiosError<RpcStatus>;

/**
 * @summary Sends a message to a thread (fire and forget).
 */
export const useRunSendMessage = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runSendMessage>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceSendMessageBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runSendMessage>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceSendMessageBody;
  },
  TContext
> => {
  const mutationOptions = getRunSendMessageMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns memory blocks with content resolved for the thread context:
- Agent-scoped blocks return base content
- Thread-scoped blocks return the thread's customization (or base if no override)

The runtime-content routes live under `/memory`; block config
templates (kind / scope / etc.) live under `/memory-blocks`
managed by `MemoryService`.
 * @summary ============================================================================
Thread Memory
============================================================================
Gets all memory blocks with resolved content for a thread.
 */
export const runGetThreadMemory = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetThreadMemoryParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetThreadMemoryResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/memory`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRunGetThreadMemoryQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  run?: string,
  agentId?: string,
  threadId?: string,
  params?: RunGetThreadMemoryParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/memory`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRunGetThreadMemoryQueryOptions = <
  TData = Awaited<ReturnType<typeof runGetThreadMemory>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetThreadMemoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetThreadMemory>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRunGetThreadMemoryQueryKey(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof runGetThreadMemory>>
  > = ({ signal }) =>
    runGetThreadMemory(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(
      organization &&
      workspace &&
      automation &&
      run &&
      agentId &&
      threadId
    ),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof runGetThreadMemory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RunGetThreadMemoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof runGetThreadMemory>>
>;
export type RunGetThreadMemoryQueryError = AxiosError<RpcStatus>;

export function useRunGetThreadMemory<
  TData = Awaited<ReturnType<typeof runGetThreadMemory>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params: undefined | RunGetThreadMemoryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetThreadMemory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetThreadMemory>>,
          TError,
          Awaited<ReturnType<typeof runGetThreadMemory>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetThreadMemory<
  TData = Awaited<ReturnType<typeof runGetThreadMemory>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetThreadMemoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetThreadMemory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetThreadMemory>>,
          TError,
          Awaited<ReturnType<typeof runGetThreadMemory>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetThreadMemory<
  TData = Awaited<ReturnType<typeof runGetThreadMemory>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetThreadMemoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetThreadMemory>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ============================================================================
Thread Memory
============================================================================
Gets all memory blocks with resolved content for a thread.
 */

export function useRunGetThreadMemory<
  TData = Awaited<ReturnType<typeof runGetThreadMemory>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetThreadMemoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetThreadMemory>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRunGetThreadMemoryQueryOptions(
    organization,
    workspace,
    automation,
    run,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Gets a specific memory block with resolved content for a thread.
 */
export const runGetThreadMemoryBlock = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  blockId: string,
  params?: RunGetThreadMemoryBlockParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1MemoryBlock>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/memory/${blockId}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRunGetThreadMemoryBlockQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  run?: string,
  agentId?: string,
  threadId?: string,
  blockId?: string,
  params?: RunGetThreadMemoryBlockParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/memory/${blockId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRunGetThreadMemoryBlockQueryOptions = <
  TData = Awaited<ReturnType<typeof runGetThreadMemoryBlock>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  blockId: string,
  params?: RunGetThreadMemoryBlockParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetThreadMemoryBlock>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRunGetThreadMemoryBlockQueryKey(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      blockId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof runGetThreadMemoryBlock>>
  > = ({ signal }) =>
    runGetThreadMemoryBlock(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      blockId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(
      organization &&
      workspace &&
      automation &&
      run &&
      agentId &&
      threadId &&
      blockId
    ),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof runGetThreadMemoryBlock>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RunGetThreadMemoryBlockQueryResult = NonNullable<
  Awaited<ReturnType<typeof runGetThreadMemoryBlock>>
>;
export type RunGetThreadMemoryBlockQueryError = AxiosError<RpcStatus>;

export function useRunGetThreadMemoryBlock<
  TData = Awaited<ReturnType<typeof runGetThreadMemoryBlock>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  blockId: string,
  params: undefined | RunGetThreadMemoryBlockParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetThreadMemoryBlock>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetThreadMemoryBlock>>,
          TError,
          Awaited<ReturnType<typeof runGetThreadMemoryBlock>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetThreadMemoryBlock<
  TData = Awaited<ReturnType<typeof runGetThreadMemoryBlock>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  blockId: string,
  params?: RunGetThreadMemoryBlockParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetThreadMemoryBlock>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetThreadMemoryBlock>>,
          TError,
          Awaited<ReturnType<typeof runGetThreadMemoryBlock>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetThreadMemoryBlock<
  TData = Awaited<ReturnType<typeof runGetThreadMemoryBlock>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  blockId: string,
  params?: RunGetThreadMemoryBlockParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetThreadMemoryBlock>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets a specific memory block with resolved content for a thread.
 */

export function useRunGetThreadMemoryBlock<
  TData = Awaited<ReturnType<typeof runGetThreadMemoryBlock>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  blockId: string,
  params?: RunGetThreadMemoryBlockParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetThreadMemoryBlock>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRunGetThreadMemoryBlockQueryOptions(
    organization,
    workspace,
    automation,
    run,
    agentId,
    threadId,
    blockId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Only thread-scoped blocks can be cleared through this endpoint.
This removes the thread's customization, revealing the base content.
Agent-scoped blocks must be cleared through the MemoryService.
Returns FAILED_PRECONDITION if the block is agent-scoped.
 * @summary Clears memory block content in a thread context.
 */
export const runClearThreadMemory = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  blockId: string,
  params?: RunClearThreadMemoryParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RunClearThreadMemory200>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/memory/${blockId}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRunClearThreadMemoryMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runClearThreadMemory>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      blockId: string;
      params?: RunClearThreadMemoryParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runClearThreadMemory>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    blockId: string;
    params?: RunClearThreadMemoryParams;
  },
  TContext
> => {
  const mutationKey = ['runClearThreadMemory'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runClearThreadMemory>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      blockId: string;
      params?: RunClearThreadMemoryParams;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      blockId,
      params,
    } = props ?? {};

    return runClearThreadMemory(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      blockId,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunClearThreadMemoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof runClearThreadMemory>>
>;

export type RunClearThreadMemoryMutationError = AxiosError<RpcStatus>;

/**
 * @summary Clears memory block content in a thread context.
 */
export const useRunClearThreadMemory = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runClearThreadMemory>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        blockId: string;
        params?: RunClearThreadMemoryParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runClearThreadMemory>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    blockId: string;
    params?: RunClearThreadMemoryParams;
  },
  TContext
> => {
  const mutationOptions = getRunClearThreadMemoryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Only thread-scoped blocks can be updated through this endpoint.
Agent-scoped blocks must be updated through the MemoryService.
Returns FAILED_PRECONDITION if the block is agent-scoped.
 * @summary Updates memory block content in a thread context.
 */
export const runUpdateThreadMemory = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  blockId: string,
  threadServiceUpdateThreadMemoryBody: ThreadServiceUpdateThreadMemoryBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1MemoryBlock>> => {
  return axios.default.patch(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/memory/${blockId}`,
    threadServiceUpdateThreadMemoryBody,
    options,
  );
};

export const getRunUpdateThreadMemoryMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runUpdateThreadMemory>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      blockId: string;
      data: ThreadServiceUpdateThreadMemoryBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runUpdateThreadMemory>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    blockId: string;
    data: ThreadServiceUpdateThreadMemoryBody;
  },
  TContext
> => {
  const mutationKey = ['runUpdateThreadMemory'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runUpdateThreadMemory>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      blockId: string;
      data: ThreadServiceUpdateThreadMemoryBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      blockId,
      data,
    } = props ?? {};

    return runUpdateThreadMemory(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      blockId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunUpdateThreadMemoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof runUpdateThreadMemory>>
>;
export type RunUpdateThreadMemoryMutationBody =
  ThreadServiceUpdateThreadMemoryBody;
export type RunUpdateThreadMemoryMutationError = AxiosError<RpcStatus>;

/**
 * @summary Updates memory block content in a thread context.
 */
export const useRunUpdateThreadMemory = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runUpdateThreadMemory>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        blockId: string;
        data: ThreadServiceUpdateThreadMemoryBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runUpdateThreadMemory>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    blockId: string;
    data: ThreadServiceUpdateThreadMemoryBody;
  },
  TContext
> => {
  const mutationOptions = getRunUpdateThreadMemoryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns NOT_FOUND if no active plan exists.
 * @summary Gets the active plan snapshot for a thread (with per-step
statuses). Distinct from `GET /plan`, which returns the template.
 */
export const runGetActivePlan = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetActivePlanParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Plan>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/plan/active`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRunGetActivePlanQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  run?: string,
  agentId?: string,
  threadId?: string,
  params?: RunGetActivePlanParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/plan/active`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRunGetActivePlanQueryOptions = <
  TData = Awaited<ReturnType<typeof runGetActivePlan>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetActivePlanParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetActivePlan>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRunGetActivePlanQueryKey(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof runGetActivePlan>>
  > = ({ signal }) =>
    runGetActivePlan(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(
      organization &&
      workspace &&
      automation &&
      run &&
      agentId &&
      threadId
    ),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof runGetActivePlan>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RunGetActivePlanQueryResult = NonNullable<
  Awaited<ReturnType<typeof runGetActivePlan>>
>;
export type RunGetActivePlanQueryError = AxiosError<RpcStatus>;

export function useRunGetActivePlan<
  TData = Awaited<ReturnType<typeof runGetActivePlan>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params: undefined | RunGetActivePlanParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetActivePlan>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetActivePlan>>,
          TError,
          Awaited<ReturnType<typeof runGetActivePlan>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetActivePlan<
  TData = Awaited<ReturnType<typeof runGetActivePlan>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetActivePlanParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetActivePlan>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetActivePlan>>,
          TError,
          Awaited<ReturnType<typeof runGetActivePlan>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetActivePlan<
  TData = Awaited<ReturnType<typeof runGetActivePlan>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetActivePlanParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetActivePlan>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets the active plan snapshot for a thread (with per-step
statuses). Distinct from `GET /plan`, which returns the template.
 */

export function useRunGetActivePlan<
  TData = Awaited<ReturnType<typeof runGetActivePlan>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetActivePlanParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetActivePlan>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRunGetActivePlanQueryOptions(
    organization,
    workspace,
    automation,
    run,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns NOT_FOUND if no active plan exists or the phase/step index
is invalid.
Returns FAILED_PRECONDITION if the thread is currently generating,
the step is not in the active phase, or the step is already
resolved.
 * @summary Marks a step on the active plan as completed or failed.
 */
export const runMarkStep = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  phaseIndex: number,
  stepIndex: number,
  threadServiceMarkStepBody: ThreadServiceMarkStepBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Plan>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/plan/active/phases/${phaseIndex}/steps/${stepIndex}:mark`,
    threadServiceMarkStepBody,
    options,
  );
};

export const getRunMarkStepMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runMarkStep>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      phaseIndex: number;
      stepIndex: number;
      data: ThreadServiceMarkStepBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runMarkStep>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    phaseIndex: number;
    stepIndex: number;
    data: ThreadServiceMarkStepBody;
  },
  TContext
> => {
  const mutationKey = ['runMarkStep'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runMarkStep>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      phaseIndex: number;
      stepIndex: number;
      data: ThreadServiceMarkStepBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      phaseIndex,
      stepIndex,
      data,
    } = props ?? {};

    return runMarkStep(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      phaseIndex,
      stepIndex,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunMarkStepMutationResult = NonNullable<
  Awaited<ReturnType<typeof runMarkStep>>
>;
export type RunMarkStepMutationBody = ThreadServiceMarkStepBody;
export type RunMarkStepMutationError = AxiosError<RpcStatus>;

/**
 * @summary Marks a step on the active plan as completed or failed.
 */
export const useRunMarkStep = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runMarkStep>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        phaseIndex: number;
        stepIndex: number;
        data: ThreadServiceMarkStepBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runMarkStep>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    phaseIndex: number;
    stepIndex: number;
    data: ThreadServiceMarkStepBody;
  },
  TContext
> => {
  const mutationOptions = getRunMarkStepMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * No generation guard — always allowed.
Returns NOT_FOUND if no active plan exists.
Returns FAILED_PRECONDITION if the plan is not active.
 * @summary Deactivates the active plan. The snapshot is kept (flagged
inactive) for status carry-over on the next activation.
 */
export const runDeactivatePlan = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceDeactivatePlanBody: ThreadServiceDeactivatePlanBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Plan>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/plan/active:deactivate`,
    threadServiceDeactivatePlanBody,
    options,
  );
};

export const getRunDeactivatePlanMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runDeactivatePlan>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDeactivatePlanBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runDeactivatePlan>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDeactivatePlanBody;
  },
  TContext
> => {
  const mutationKey = ['runDeactivatePlan'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runDeactivatePlan>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDeactivatePlanBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runDeactivatePlan(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunDeactivatePlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof runDeactivatePlan>>
>;
export type RunDeactivatePlanMutationBody = ThreadServiceDeactivatePlanBody;
export type RunDeactivatePlanMutationError = AxiosError<RpcStatus>;

/**
 * @summary Deactivates the active plan. The snapshot is kept (flagged
inactive) for status carry-over on the next activation.
 */
export const useRunDeactivatePlan = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runDeactivatePlan>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceDeactivatePlanBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runDeactivatePlan>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDeactivatePlanBody;
  },
  TContext
> => {
  const mutationOptions = getRunDeactivatePlanMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Clears all step statuses and failure reasons. If the plan is
active, it is deactivated first before resetting.
Returns NOT_FOUND if no active plan exists.
Returns FAILED_PRECONDITION if the thread is currently generating.
 * @summary Resets all step statuses on the active plan back to pending.
 */
export const runResetPlan = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceResetPlanBody: ThreadServiceResetPlanBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Plan>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/plan/active:reset`,
    threadServiceResetPlanBody,
    options,
  );
};

export const getRunResetPlanMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runResetPlan>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceResetPlanBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runResetPlan>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceResetPlanBody;
  },
  TContext
> => {
  const mutationKey = ['runResetPlan'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runResetPlan>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceResetPlanBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runResetPlan(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunResetPlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof runResetPlan>>
>;
export type RunResetPlanMutationBody = ThreadServiceResetPlanBody;
export type RunResetPlanMutationError = AxiosError<RpcStatus>;

/**
 * @summary Resets all step statuses on the active plan back to pending.
 */
export const useRunResetPlan = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runResetPlan>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceResetPlanBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runResetPlan>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceResetPlanBody;
  },
  TContext
> => {
  const mutationOptions = getRunResetPlanMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns NOT_FOUND if no plan template exists.
Returns FAILED_PRECONDITION if the thread is currently generating,
the plan is already active, or the template has no phases.
 * @summary Activates the plan for a thread. Snapshots the current template
plan and carries over statuses from any previous snapshot by id.
 */
export const runActivatePlan = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceActivatePlanBody: ThreadServiceActivatePlanBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Plan>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/plan:activate`,
    threadServiceActivatePlanBody,
    options,
  );
};

export const getRunActivatePlanMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runActivatePlan>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceActivatePlanBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runActivatePlan>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceActivatePlanBody;
  },
  TContext
> => {
  const mutationKey = ['runActivatePlan'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runActivatePlan>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceActivatePlanBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runActivatePlan(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunActivatePlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof runActivatePlan>>
>;
export type RunActivatePlanMutationBody = ThreadServiceActivatePlanBody;
export type RunActivatePlanMutationError = AxiosError<RpcStatus>;

/**
 * @summary Activates the plan for a thread. Snapshots the current template
plan and carries over statuses from any previous snapshot by id.
 */
export const useRunActivatePlan = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runActivatePlan>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceActivatePlanBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runActivatePlan>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceActivatePlanBody;
  },
  TContext
> => {
  const mutationOptions = getRunActivatePlanMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Read-only and observational. The queue is the to-do list of not-yet-started
work; the in-flight suspension itself lives in the event-log tail (see
GetEvents), not here. Groups are returned in drain order (head first).
 * @summary Retrieves the thread's durable queue: the deferred suspend-type work
(remote tool calls, an interrupt, a sleep, a transfer, sub-agent
task/resume) and any parked user input not yet enacted.
 */
export const runGetQueue = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetQueueParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetQueueResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/queue`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRunGetQueueQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  run?: string,
  agentId?: string,
  threadId?: string,
  params?: RunGetQueueParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/queue`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRunGetQueueQueryOptions = <
  TData = Awaited<ReturnType<typeof runGetQueue>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetQueueParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof runGetQueue>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRunGetQueueQueryKey(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof runGetQueue>>> = ({
    signal,
  }) =>
    runGetQueue(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(
      organization &&
      workspace &&
      automation &&
      run &&
      agentId &&
      threadId
    ),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof runGetQueue>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RunGetQueueQueryResult = NonNullable<
  Awaited<ReturnType<typeof runGetQueue>>
>;
export type RunGetQueueQueryError = AxiosError<RpcStatus>;

export function useRunGetQueue<
  TData = Awaited<ReturnType<typeof runGetQueue>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params: undefined | RunGetQueueParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof runGetQueue>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetQueue>>,
          TError,
          Awaited<ReturnType<typeof runGetQueue>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetQueue<
  TData = Awaited<ReturnType<typeof runGetQueue>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetQueueParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof runGetQueue>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetQueue>>,
          TError,
          Awaited<ReturnType<typeof runGetQueue>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetQueue<
  TData = Awaited<ReturnType<typeof runGetQueue>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetQueueParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof runGetQueue>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieves the thread's durable queue: the deferred suspend-type work
(remote tool calls, an interrupt, a sleep, a transfer, sub-agent
task/resume) and any parked user input not yet enacted.
 */

export function useRunGetQueue<
  TData = Awaited<ReturnType<typeof runGetQueue>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetQueueParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof runGetQueue>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRunGetQueueQueryOptions(
    organization,
    workspace,
    automation,
    run,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Appends a synthetic ToolCallStart (plus one ToolCallArgument per supplied
argument) to the thread event log under the generation lock, executes the
tool through the normal dispatcher, and continues with an LLM turn that
has the tool result in context. Equivalent in effect to the LLM having
chosen to call this tool itself.
 * @summary Injects a deterministic tool call into a thread.
 */
export const runSendToolCall = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceSendToolCallBody: ThreadServiceSendToolCallBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1SendToolCallResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/tool-calls`,
    threadServiceSendToolCallBody,
    options,
  );
};

export const getRunSendToolCallMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runSendToolCall>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceSendToolCallBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runSendToolCall>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceSendToolCallBody;
  },
  TContext
> => {
  const mutationKey = ['runSendToolCall'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runSendToolCall>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceSendToolCallBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runSendToolCall(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunSendToolCallMutationResult = NonNullable<
  Awaited<ReturnType<typeof runSendToolCall>>
>;
export type RunSendToolCallMutationBody = ThreadServiceSendToolCallBody;
export type RunSendToolCallMutationError = AxiosError<RpcStatus>;

/**
 * @summary Injects a deterministic tool call into a thread.
 */
export const useRunSendToolCall = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runSendToolCall>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceSendToolCallBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runSendToolCall>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceSendToolCallBody;
  },
  TContext
> => {
  const mutationOptions = getRunSendToolCallMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Remote tools pause generation when called, waiting for an external system
to execute them and return the result via this RPC. Generation resumes
once the result is received.
 * @summary Sends a tool execution result for a remote tool.
 */
export const runSendToolResult = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceSendToolResultBody: ThreadServiceSendToolResultBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1SendToolResultResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/tool-results`,
    threadServiceSendToolResultBody,
    options,
  );
};

export const getRunSendToolResultMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runSendToolResult>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceSendToolResultBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runSendToolResult>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceSendToolResultBody;
  },
  TContext
> => {
  const mutationKey = ['runSendToolResult'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runSendToolResult>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceSendToolResultBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runSendToolResult(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunSendToolResultMutationResult = NonNullable<
  Awaited<ReturnType<typeof runSendToolResult>>
>;
export type RunSendToolResultMutationBody = ThreadServiceSendToolResultBody;
export type RunSendToolResultMutationError = AxiosError<RpcStatus>;

/**
 * @summary Sends a tool execution result for a remote tool.
 */
export const useRunSendToolResult = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runSendToolResult>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceSendToolResultBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runSendToolResult>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceSendToolResultBody;
  },
  TContext
> => {
  const mutationOptions = getRunSendToolResultMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns tool details resolved with thread variables.
 * @summary Gets a single tool by its stable tool_id for a specific thread.
 */
export const runGetTool = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  toolId: string,
  params?: RunGetToolParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Tool>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/tools/${toolId}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRunGetToolQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  run?: string,
  agentId?: string,
  threadId?: string,
  toolId?: string,
  params?: RunGetToolParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/tools/${toolId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRunGetToolQueryOptions = <
  TData = Awaited<ReturnType<typeof runGetTool>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  toolId: string,
  params?: RunGetToolParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof runGetTool>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRunGetToolQueryKey(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      toolId,
      params,
    );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof runGetTool>>> = ({
    signal,
  }) =>
    runGetTool(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      toolId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(
      organization &&
      workspace &&
      automation &&
      run &&
      agentId &&
      threadId &&
      toolId
    ),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof runGetTool>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RunGetToolQueryResult = NonNullable<
  Awaited<ReturnType<typeof runGetTool>>
>;
export type RunGetToolQueryError = AxiosError<RpcStatus>;

export function useRunGetTool<
  TData = Awaited<ReturnType<typeof runGetTool>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  toolId: string,
  params: undefined | RunGetToolParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof runGetTool>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetTool>>,
          TError,
          Awaited<ReturnType<typeof runGetTool>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetTool<
  TData = Awaited<ReturnType<typeof runGetTool>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  toolId: string,
  params?: RunGetToolParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof runGetTool>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetTool>>,
          TError,
          Awaited<ReturnType<typeof runGetTool>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetTool<
  TData = Awaited<ReturnType<typeof runGetTool>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  toolId: string,
  params?: RunGetToolParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof runGetTool>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets a single tool by its stable tool_id for a specific thread.
 */

export function useRunGetTool<
  TData = Awaited<ReturnType<typeof runGetTool>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  toolId: string,
  params?: RunGetToolParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof runGetTool>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRunGetToolQueryOptions(
    organization,
    workspace,
    automation,
    run,
    agentId,
    threadId,
    toolId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The tool executes in the context of a thread (for artifact, memory, and
plan access) but nothing is appended to thread history. Useful for testing,
automation, and external integrations.
 * @summary Invokes a tool directly without LLM involvement.
 */
export const runInvokeTool = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceInvokeToolBody: ThreadServiceInvokeToolBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1InvokeToolResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/tools:invoke`,
    threadServiceInvokeToolBody,
    options,
  );
};

export const getRunInvokeToolMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runInvokeTool>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceInvokeToolBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runInvokeTool>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceInvokeToolBody;
  },
  TContext
> => {
  const mutationKey = ['runInvokeTool'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runInvokeTool>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceInvokeToolBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runInvokeTool(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunInvokeToolMutationResult = NonNullable<
  Awaited<ReturnType<typeof runInvokeTool>>
>;
export type RunInvokeToolMutationBody = ThreadServiceInvokeToolBody;
export type RunInvokeToolMutationError = AxiosError<RpcStatus>;

/**
 * @summary Invokes a tool directly without LLM involvement.
 */
export const useRunInvokeTool = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runInvokeTool>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceInvokeToolBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runInvokeTool>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceInvokeToolBody;
  },
  TContext
> => {
  const mutationOptions = getRunInvokeToolMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * When the agent has no utility generator configured this falls back
to the main generator, so the returned info always describes the
model that will actually run utility tasks.
 * @summary Gets model information and capabilities for the agent's utility
generator (the secondary generator used for thread titling and
other lightweight LLM calls around the conversation).
 */
export const runGetUtilityGeneratorModelInfo = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetUtilityGeneratorModelInfoParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ModelInfo>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/utility-generator:model-info`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRunGetUtilityGeneratorModelInfoQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  run?: string,
  agentId?: string,
  threadId?: string,
  params?: RunGetUtilityGeneratorModelInfoParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}/utility-generator:model-info`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRunGetUtilityGeneratorModelInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof runGetUtilityGeneratorModelInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetUtilityGeneratorModelInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetUtilityGeneratorModelInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRunGetUtilityGeneratorModelInfoQueryKey(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof runGetUtilityGeneratorModelInfo>>
  > = ({ signal }) =>
    runGetUtilityGeneratorModelInfo(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(
      organization &&
      workspace &&
      automation &&
      run &&
      agentId &&
      threadId
    ),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof runGetUtilityGeneratorModelInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RunGetUtilityGeneratorModelInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof runGetUtilityGeneratorModelInfo>>
>;
export type RunGetUtilityGeneratorModelInfoQueryError = AxiosError<RpcStatus>;

export function useRunGetUtilityGeneratorModelInfo<
  TData = Awaited<ReturnType<typeof runGetUtilityGeneratorModelInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params: undefined | RunGetUtilityGeneratorModelInfoParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetUtilityGeneratorModelInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetUtilityGeneratorModelInfo>>,
          TError,
          Awaited<ReturnType<typeof runGetUtilityGeneratorModelInfo>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetUtilityGeneratorModelInfo<
  TData = Awaited<ReturnType<typeof runGetUtilityGeneratorModelInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetUtilityGeneratorModelInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetUtilityGeneratorModelInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetUtilityGeneratorModelInfo>>,
          TError,
          Awaited<ReturnType<typeof runGetUtilityGeneratorModelInfo>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetUtilityGeneratorModelInfo<
  TData = Awaited<ReturnType<typeof runGetUtilityGeneratorModelInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetUtilityGeneratorModelInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetUtilityGeneratorModelInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets model information and capabilities for the agent's utility
generator (the secondary generator used for thread titling and
other lightweight LLM calls around the conversation).
 */

export function useRunGetUtilityGeneratorModelInfo<
  TData = Awaited<ReturnType<typeof runGetUtilityGeneratorModelInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  params?: RunGetUtilityGeneratorModelInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetUtilityGeneratorModelInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRunGetUtilityGeneratorModelInfoQueryOptions(
    organization,
    workspace,
    automation,
    run,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Compaction summarizes conversation history to reduce context size while
preserving essential information. This RPC emits a CompactStart event
and returns the compact_id for tracking.

The actual compaction is performed asynchronously. Once complete, a
CompactComplete event with the summary content should be added to the
thread using the returned compact_id.

While compaction is in progress (CompactStart without CompactComplete),
the UI should block user input.
 * @summary Starts context compaction for a thread.
 */
export const runStartCompaction = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceStartCompactionBody: ThreadServiceStartCompactionBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1StartCompactionResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}:compact`,
    threadServiceStartCompactionBody,
    options,
  );
};

export const getRunStartCompactionMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runStartCompaction>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceStartCompactionBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runStartCompaction>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceStartCompactionBody;
  },
  TContext
> => {
  const mutationKey = ['runStartCompaction'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runStartCompaction>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceStartCompactionBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runStartCompaction(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunStartCompactionMutationResult = NonNullable<
  Awaited<ReturnType<typeof runStartCompaction>>
>;
export type RunStartCompactionMutationBody = ThreadServiceStartCompactionBody;
export type RunStartCompactionMutationError = AxiosError<RpcStatus>;

/**
 * @summary Starts context compaction for a thread.
 */
export const useRunStartCompaction = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runStartCompaction>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceStartCompactionBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runStartCompaction>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceStartCompactionBody;
  },
  TContext
> => {
  const mutationOptions = getRunStartCompactionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Dehydrates an idle thread: archives all of its data to the configured
dehydrated thread store and leaves a tombstone that still lists but cannot
generate. Returns FAILED_PRECONDITION when dehydration is not configured or
the thread is ineligible (not quiescent, queue non-empty, or sleeping).
 */
export const runDehydrateThread = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceDehydrateThreadBody: ThreadServiceDehydrateThreadBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Thread>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}:dehydrate`,
    threadServiceDehydrateThreadBody,
    options,
  );
};

export const getRunDehydrateThreadMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runDehydrateThread>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDehydrateThreadBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runDehydrateThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDehydrateThreadBody;
  },
  TContext
> => {
  const mutationKey = ['runDehydrateThread'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runDehydrateThread>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceDehydrateThreadBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runDehydrateThread(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunDehydrateThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof runDehydrateThread>>
>;
export type RunDehydrateThreadMutationBody = ThreadServiceDehydrateThreadBody;
export type RunDehydrateThreadMutationError = AxiosError<RpcStatus>;

/**
 * @summary Dehydrates an idle thread: archives all of its data to the configured
dehydrated thread store and leaves a tombstone that still lists but cannot
generate. Returns FAILED_PRECONDITION when dehydration is not configured or
the thread is ineligible (not quiescent, queue non-empty, or sleeping).
 */
export const useRunDehydrateThread = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runDehydrateThread>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceDehydrateThreadBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runDehydrateThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceDehydrateThreadBody;
  },
  TContext
> => {
  const mutationOptions = getRunDehydrateThreadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Creates a new thread that is a complete copy of the source thread,
including events, feedback, memory customizations, scratchpad, plan,
and template config customizations.
Returns FAILED_PRECONDITION if the source thread is currently generating.
 * @summary Forks (duplicates) a thread with all its data.
 */
export const runForkThread = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceForkThreadBody: ThreadServiceForkThreadBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Thread>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}:fork`,
    threadServiceForkThreadBody,
    options,
  );
};

export const getRunForkThreadMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runForkThread>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceForkThreadBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runForkThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceForkThreadBody;
  },
  TContext
> => {
  const mutationKey = ['runForkThread'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runForkThread>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceForkThreadBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runForkThread(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunForkThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof runForkThread>>
>;
export type RunForkThreadMutationBody = ThreadServiceForkThreadBody;
export type RunForkThreadMutationError = AxiosError<RpcStatus>;

/**
 * @summary Forks (duplicates) a thread with all its data.
 */
export const useRunForkThread = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runForkThread>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceForkThreadBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runForkThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceForkThreadBody;
  },
  TContext
> => {
  const mutationOptions = getRunForkThreadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Rehydrates a dehydrated thread: restores its data from the archive and
returns it to normal operation. Returns FAILED_PRECONDITION when the thread
is not dehydrated.
 */
export const runRehydrateThread = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceRehydrateThreadBody: ThreadServiceRehydrateThreadBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Thread>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}:rehydrate`,
    threadServiceRehydrateThreadBody,
    options,
  );
};

export const getRunRehydrateThreadMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runRehydrateThread>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceRehydrateThreadBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runRehydrateThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceRehydrateThreadBody;
  },
  TContext
> => {
  const mutationKey = ['runRehydrateThread'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runRehydrateThread>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceRehydrateThreadBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runRehydrateThread(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunRehydrateThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof runRehydrateThread>>
>;
export type RunRehydrateThreadMutationBody = ThreadServiceRehydrateThreadBody;
export type RunRehydrateThreadMutationError = AxiosError<RpcStatus>;

/**
 * @summary Rehydrates a dehydrated thread: restores its data from the archive and
returns it to normal operation. Returns FAILED_PRECONDITION when the thread
is not dehydrated.
 */
export const useRunRehydrateThread = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runRehydrateThread>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceRehydrateThreadBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runRehydrateThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceRehydrateThreadBody;
  },
  TContext
> => {
  const mutationOptions = getRunRehydrateThreadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * If a generation is currently running, it will be cancelled and a
GenerationFailed event with STOPPED kind will be emitted. If no
generation is in progress, this is a no-op and returns stopped=false.
 * @summary Stops an in-progress generation in a thread.
 */
export const runStop = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceStopBody: ThreadServiceStopBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1StopResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}:stop`,
    threadServiceStopBody,
    options,
  );
};

export const getRunStopMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runStop>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceStopBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runStop>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceStopBody;
  },
  TContext
> => {
  const mutationKey = ['runStop'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runStop>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceStopBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runStop(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunStopMutationResult = NonNullable<
  Awaited<ReturnType<typeof runStop>>
>;
export type RunStopMutationBody = ThreadServiceStopBody;
export type RunStopMutationError = AxiosError<RpcStatus>;

/**
 * @summary Stops an in-progress generation in a thread.
 */
export const useRunStop = <TError = AxiosError<RpcStatus>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runStop>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceStopBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runStop>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceStopBody;
  },
  TContext
> => {
  const mutationOptions = getRunStopMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Operator-forced transfer: hand the live conversation to another profile on
the same thread (a profile swap), bypassing the agent allowlist. Triggers a
generation as the new profile; observe it via the event stream.
 */
export const runTransfer = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceTransferBody: ThreadServiceTransferBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RunTransfer200>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}:transfer`,
    threadServiceTransferBody,
    options,
  );
};

export const getRunTransferMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runTransfer>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceTransferBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runTransfer>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceTransferBody;
  },
  TContext
> => {
  const mutationKey = ['runTransfer'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runTransfer>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceTransferBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runTransfer(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunTransferMutationResult = NonNullable<
  Awaited<ReturnType<typeof runTransfer>>
>;
export type RunTransferMutationBody = ThreadServiceTransferBody;
export type RunTransferMutationError = AxiosError<RpcStatus>;

/**
 * @summary Operator-forced transfer: hand the live conversation to another profile on
the same thread (a profile swap), bypassing the agent allowlist. Triggers a
generation as the new profile; observe it via the event stream.
 */
export const useRunTransfer = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runTransfer>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceTransferBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runTransfer>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceTransferBody;
  },
  TContext
> => {
  const mutationOptions = getRunTransferMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Atomically ends the pending sleep with `interrupted_by_user = true`,
cancels the scheduled wake task, and triggers a new generation so the
LLM observes the early return in its rebuilt history. No-op when no
sleep is pending; the call still triggers a normal Reminder-driven
resume in that case.
 * @summary Wakes a thread that is currently sleeping (UI "Wake up" button).
 */
export const runWake = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadId: string,
  threadServiceWakeBody: ThreadServiceWakeBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1WakeResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads/${threadId}:wake`,
    threadServiceWakeBody,
    options,
  );
};

export const getRunWakeMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runWake>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceWakeBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runWake>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceWakeBody;
  },
  TContext
> => {
  const mutationKey = ['runWake'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runWake>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      threadId: string;
      data: ThreadServiceWakeBody;
    }
  > = props => {
    const {
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
    } = props ?? {};

    return runWake(
      organization,
      workspace,
      automation,
      run,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunWakeMutationResult = NonNullable<
  Awaited<ReturnType<typeof runWake>>
>;
export type RunWakeMutationBody = ThreadServiceWakeBody;
export type RunWakeMutationError = AxiosError<RpcStatus>;

/**
 * @summary Wakes a thread that is currently sleeping (UI "Wake up" button).
 */
export const useRunWake = <TError = AxiosError<RpcStatus>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runWake>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        threadId: string;
        data: ThreadServiceWakeBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runWake>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    threadId: string;
    data: ThreadServiceWakeBody;
  },
  TContext
> => {
  const mutationOptions = getRunWakeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * The bulk counterpart of UpgradeThread, for re-pinning an agent's whole
fleet after a backward-incompatible version change without iterating
thread-by-thread. Threads may be narrowed by an REL `filter` (empty means
all) and are scoped to the request's parent. Each thread is upgraded
independently: one that is already current, is missing required
variables, or fails to write is reported individually and does not abort
the rest. The response carries a per-thread result and rollup counts.
 * @summary Move every thread of an agent to a target agent version in one call.
 */
export const runUpgradeAllThreads = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agentId: string,
  threadServiceUpgradeAllThreadsBody: ThreadServiceUpgradeAllThreadsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1UpgradeAllThreadsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agentId}/threads:upgradeAll`,
    threadServiceUpgradeAllThreadsBody,
    options,
  );
};

export const getRunUpgradeAllThreadsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runUpgradeAllThreads>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      data: ThreadServiceUpgradeAllThreadsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runUpgradeAllThreads>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    data: ThreadServiceUpgradeAllThreadsBody;
  },
  TContext
> => {
  const mutationKey = ['runUpgradeAllThreads'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runUpgradeAllThreads>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agentId: string;
      data: ThreadServiceUpgradeAllThreadsBody;
    }
  > = props => {
    const { organization, workspace, automation, run, agentId, data } =
      props ?? {};

    return runUpgradeAllThreads(
      organization,
      workspace,
      automation,
      run,
      agentId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunUpgradeAllThreadsMutationResult = NonNullable<
  Awaited<ReturnType<typeof runUpgradeAllThreads>>
>;
export type RunUpgradeAllThreadsMutationBody =
  ThreadServiceUpgradeAllThreadsBody;
export type RunUpgradeAllThreadsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Move every thread of an agent to a target agent version in one call.
 */
export const useRunUpgradeAllThreads = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runUpgradeAllThreads>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agentId: string;
        data: ThreadServiceUpgradeAllThreadsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runUpgradeAllThreads>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agentId: string;
    data: ThreadServiceUpgradeAllThreadsBody;
  },
  TContext
> => {
  const mutationOptions = getRunUpgradeAllThreadsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Tools are resolved with thread variables, so tool availability may vary
between threads depending on variable configuration. Use this endpoint
to get the actual tools available in a thread context.

Also mirrored on `ToolCatalogService::ListTools` (same shape; the
catalog service exposes `:diff` next to it). New callers should
prefer the `ToolCatalogService` variant; this one is kept for
backwards-compatible gRPC clients.
 * @summary ============================================================================
Tool Discovery (Thread-Scoped)
============================================================================
Lists tools available to an agent for a specific thread.
 */
export const runListTools = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  v1ListToolsRequest: V1ListToolsRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListToolsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/rain.v1.ThreadService/ListTools`,
    v1ListToolsRequest,
    options,
  );
};

export const getRunListToolsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runListTools>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      data: V1ListToolsRequest;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runListTools>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    data: V1ListToolsRequest;
  },
  TContext
> => {
  const mutationKey = ['runListTools'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runListTools>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      data: V1ListToolsRequest;
    }
  > = props => {
    const { organization, workspace, automation, run, data } = props ?? {};

    return runListTools(
      organization,
      workspace,
      automation,
      run,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunListToolsMutationResult = NonNullable<
  Awaited<ReturnType<typeof runListTools>>
>;
export type RunListToolsMutationBody = V1ListToolsRequest;
export type RunListToolsMutationError = AxiosError<RpcStatus>;

/**
 * @summary ============================================================================
Tool Discovery (Thread-Scoped)
============================================================================
Lists tools available to an agent for a specific thread.
 */
export const useRunListTools = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runListTools>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        data: V1ListToolsRequest;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runListTools>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    data: V1ListToolsRequest;
  },
  TContext
> => {
  const mutationOptions = getRunListToolsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Streams live status transitions for every thread of one agent.
 */
export const runSubscribeAgentThreadStatus = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  v1SubscribeAgentThreadStatusRequest: V1SubscribeAgentThreadStatusRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RunSubscribeAgentThreadStatus200>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/rain.v1.ThreadService/SubscribeAgentThreadStatus`,
    v1SubscribeAgentThreadStatusRequest,
    options,
  );
};

export const getRunSubscribeAgentThreadStatusMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runSubscribeAgentThreadStatus>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      data: V1SubscribeAgentThreadStatusRequest;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runSubscribeAgentThreadStatus>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    data: V1SubscribeAgentThreadStatusRequest;
  },
  TContext
> => {
  const mutationKey = ['runSubscribeAgentThreadStatus'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runSubscribeAgentThreadStatus>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      data: V1SubscribeAgentThreadStatusRequest;
    }
  > = props => {
    const { organization, workspace, automation, run, data } = props ?? {};

    return runSubscribeAgentThreadStatus(
      organization,
      workspace,
      automation,
      run,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunSubscribeAgentThreadStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof runSubscribeAgentThreadStatus>>
>;
export type RunSubscribeAgentThreadStatusMutationBody =
  V1SubscribeAgentThreadStatusRequest;
export type RunSubscribeAgentThreadStatusMutationError = AxiosError<RpcStatus>;

/**
 * @summary Streams live status transitions for every thread of one agent.
 */
export const useRunSubscribeAgentThreadStatus = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runSubscribeAgentThreadStatus>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        data: V1SubscribeAgentThreadStatusRequest;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runSubscribeAgentThreadStatus>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    data: V1SubscribeAgentThreadStatusRequest;
  },
  TContext
> => {
  const mutationOptions =
    getRunSubscribeAgentThreadStatusMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns a stream of events for the thread. If include_history is true,
existing events are sent first, followed by new events as they occur.
The stream stays open until the client disconnects.

This is the gRPC streaming alternative to SSE for internal clients.
 * @summary ============================================================================
Streaming Subscription
============================================================================
Subscribes to a thread's event stream.
 */
export const runSubscribeThread = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  v1SubscribeThreadRequest: V1SubscribeThreadRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RunSubscribeThread200>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/rain.v1.ThreadService/SubscribeThread`,
    v1SubscribeThreadRequest,
    options,
  );
};

export const getRunSubscribeThreadMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runSubscribeThread>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      data: V1SubscribeThreadRequest;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runSubscribeThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    data: V1SubscribeThreadRequest;
  },
  TContext
> => {
  const mutationKey = ['runSubscribeThread'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runSubscribeThread>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      data: V1SubscribeThreadRequest;
    }
  > = props => {
    const { organization, workspace, automation, run, data } = props ?? {};

    return runSubscribeThread(
      organization,
      workspace,
      automation,
      run,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunSubscribeThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof runSubscribeThread>>
>;
export type RunSubscribeThreadMutationBody = V1SubscribeThreadRequest;
export type RunSubscribeThreadMutationError = AxiosError<RpcStatus>;

/**
 * @summary ============================================================================
Streaming Subscription
============================================================================
Subscribes to a thread's event stream.
 */
export const useRunSubscribeThread = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runSubscribeThread>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        data: V1SubscribeThreadRequest;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runSubscribeThread>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    data: V1SubscribeThreadRequest;
  },
  TContext
> => {
  const mutationOptions = getRunSubscribeThreadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Streams live status transitions for every thread within the caller's
parent scope (the cross-agent Threads console).
 */
export const runSubscribeThreadStatus = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  v1SubscribeThreadStatusRequest: V1SubscribeThreadStatusRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RunSubscribeThreadStatus200>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/rain.v1.ThreadService/SubscribeThreadStatus`,
    v1SubscribeThreadStatusRequest,
    options,
  );
};

export const getRunSubscribeThreadStatusMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runSubscribeThreadStatus>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      data: V1SubscribeThreadStatusRequest;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runSubscribeThreadStatus>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    data: V1SubscribeThreadStatusRequest;
  },
  TContext
> => {
  const mutationKey = ['runSubscribeThreadStatus'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runSubscribeThreadStatus>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      data: V1SubscribeThreadStatusRequest;
    }
  > = props => {
    const { organization, workspace, automation, run, data } = props ?? {};

    return runSubscribeThreadStatus(
      organization,
      workspace,
      automation,
      run,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RunSubscribeThreadStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof runSubscribeThreadStatus>>
>;
export type RunSubscribeThreadStatusMutationBody =
  V1SubscribeThreadStatusRequest;
export type RunSubscribeThreadStatusMutationError = AxiosError<RpcStatus>;

/**
 * @summary Streams live status transitions for every thread within the caller's
parent scope (the cross-agent Threads console).
 */
export const useRunSubscribeThreadStatus = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runSubscribeThreadStatus>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        data: V1SubscribeThreadStatusRequest;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runSubscribeThreadStatus>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    data: V1SubscribeThreadStatusRequest;
  },
  TContext
> => {
  const mutationOptions = getRunSubscribeThreadStatusMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Lists threads across every agent visible to the caller's parent scope
(the cross-agent Threads console) — server-paged and searched, each
thread carrying its materialized status and its owning agent's name.
 */
export const runListAllThreads = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  params?: RunListAllThreadsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListAllThreadsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/threads`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRunListAllThreadsQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  run?: string,
  params?: RunListAllThreadsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/threads`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRunListAllThreadsQueryOptions = <
  TData = Awaited<ReturnType<typeof runListAllThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  params?: RunListAllThreadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runListAllThreads>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRunListAllThreadsQueryKey(
      organization,
      workspace,
      automation,
      run,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof runListAllThreads>>
  > = ({ signal }) =>
    runListAllThreads(organization, workspace, automation, run, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation && run),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof runListAllThreads>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RunListAllThreadsQueryResult = NonNullable<
  Awaited<ReturnType<typeof runListAllThreads>>
>;
export type RunListAllThreadsQueryError = AxiosError<RpcStatus>;

export function useRunListAllThreads<
  TData = Awaited<ReturnType<typeof runListAllThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  params: undefined | RunListAllThreadsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runListAllThreads>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof runListAllThreads>>,
          TError,
          Awaited<ReturnType<typeof runListAllThreads>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunListAllThreads<
  TData = Awaited<ReturnType<typeof runListAllThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  params?: RunListAllThreadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runListAllThreads>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof runListAllThreads>>,
          TError,
          Awaited<ReturnType<typeof runListAllThreads>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunListAllThreads<
  TData = Awaited<ReturnType<typeof runListAllThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  params?: RunListAllThreadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runListAllThreads>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists threads across every agent visible to the caller's parent scope
(the cross-agent Threads console) — server-paged and searched, each
thread carrying its materialized status and its owning agent's name.
 */

export function useRunListAllThreads<
  TData = Awaited<ReturnType<typeof runListAllThreads>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  params?: RunListAllThreadsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runListAllThreads>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRunListAllThreadsQueryOptions(
    organization,
    workspace,
    automation,
    run,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary The thread console's discovered filter schema: filterable fields with
operators, value types, and in-scope values with counts (agent and
origin ids carry display names). `query` scopes the counts; the active
filter is not an input.
 */
export const runGetFilterSchema = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  params?: RunGetFilterSchemaParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1FilterSchemaResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/threads:filter-schema`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRunGetFilterSchemaQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  run?: string,
  params?: RunGetFilterSchemaParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/threads:filter-schema`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRunGetFilterSchemaQueryOptions = <
  TData = Awaited<ReturnType<typeof runGetFilterSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  params?: RunGetFilterSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetFilterSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRunGetFilterSchemaQueryKey(
      organization,
      workspace,
      automation,
      run,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof runGetFilterSchema>>
  > = ({ signal }) =>
    runGetFilterSchema(organization, workspace, automation, run, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation && run),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof runGetFilterSchema>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RunGetFilterSchemaQueryResult = NonNullable<
  Awaited<ReturnType<typeof runGetFilterSchema>>
>;
export type RunGetFilterSchemaQueryError = AxiosError<RpcStatus>;

export function useRunGetFilterSchema<
  TData = Awaited<ReturnType<typeof runGetFilterSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  params: undefined | RunGetFilterSchemaParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetFilterSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetFilterSchema>>,
          TError,
          Awaited<ReturnType<typeof runGetFilterSchema>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetFilterSchema<
  TData = Awaited<ReturnType<typeof runGetFilterSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  params?: RunGetFilterSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetFilterSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof runGetFilterSchema>>,
          TError,
          Awaited<ReturnType<typeof runGetFilterSchema>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunGetFilterSchema<
  TData = Awaited<ReturnType<typeof runGetFilterSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  params?: RunGetFilterSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetFilterSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary The thread console's discovered filter schema: filterable fields with
operators, value types, and in-scope values with counts (agent and
origin ids carry display names). `query` scopes the counts; the active
filter is not an input.
 */

export function useRunGetFilterSchema<
  TData = Awaited<ReturnType<typeof runGetFilterSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  params?: RunGetFilterSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof runGetFilterSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRunGetFilterSchemaQueryOptions(
    organization,
    workspace,
    automation,
    run,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
